import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {

    const [part, setPart] = useState('');
    const [make, setMake] = useState('');
    const [model, setModel] = useState('');
    const [year, setYear] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [comment, setComment] = useState('');
    const [models, setModels] = useState([]);
    const navigate = useNavigate();

    // Store the models in an object categorized by make
    const modelsByMake = {
        Acura: [
            { value: "Acura CL", text: "Acura CL" },
            { value: "Acura CSX", text: "Acura CSX" },
            { value: "Acura EL", text: "Acura EL" },
            { value: "Acura ILX", text: "Acura ILX" },
            { value: "Acura Integra", text: "Acura Integra" },
            { value: "Acura Legend", text: "Acura Legend" },
            { value: "Acura MDX", text: "Acura MDX" },
            { value: "Acura NSX", text: "Acura NSX" },
            { value: "Acura RDX", text: "Acura RDX" },
            { value: "Acura RL", text: "Acura RL" },
            { value: "Acura RLX", text: "Acura RLX" },
            { value: "Acura RSX", text: "Acura RSX" },
            { value: "Acura SLX", text: "Acura SLX" },
            { value: "Acura TL", text: "Acura TL" },
            { value: "Acura TLX", text: "Acura TLX" },
            { value: "Acura TSX", text: "Acura TSX" },
            { value: "Acura Vigor", text: "Acura Vigor" },
            { value: "Acura ZDX", text: "Acura ZDX" },
      ],
      Alfa: [
            { value: "Alfa 147", text: "Alfa 147" },
            { value: "Alfa 164 Sedan", text: "Alfa 164 Sedan" },
            { value: "Alfa 1750", text: "Alfa 1750" },
            { value: "Alfa 4C", text: "Alfa 4C" },
            { value: "Alfa Alfetta", text: "Alfa Alfetta" },
            { value: "Alfa GTV6", text: "Alfa GTV6" },
            { value: "Alfa Giulia", text: "Alfa Giulia" },
            { value: "Alfa Giulia 1600", text: "Alfa Giulia 1600" },
            { value: "Alfa Giulietta", text: "Alfa Giulietta" },
            { value: "Alfa Milano", text: "Alfa Milano" },
            { value: "Alfa Mito", text: "Alfa Mito" },
            { value: "Alfa Spider-1600", text: "Alfa Spider-1600" },
            { value: "Alfa Spider-1600 Duetto", text: "Alfa Spider-1600 Duetto" },
            { value: "Alfa Spider-2000", text: "Alfa Spider-2000" },
            { value: "Alfa Stelvio", text: "Alfa Stelvio" },
            { value: "Alfa Tonale", text: "Alfa Tonale" },
      ],
      AMC: [
            { value: "AMC Ambassador", text: "AMC Ambassador" },
            { value: "AMC American", text: "AMC American" },
            { value: "AMC AMX", text: "AMC AMX" },
            { value: "AMC Classic", text: "AMC Classic" },
            { value: "AMC Concord", text: "AMC Concord" },
            { value: "AMC Eagle", text: "AMC Eagle" },
            { value: "AMC Gremlin", text: "AMC Gremlin" },
            { value: "AMC Hornet", text: "AMC Hornet" },
            { value: "AMC Javelin", text: "AMC Javelin" },
            { value: "AMC Marlin", text: "AMC Marlin" },
            { value: "AMC Matador", text: "AMC Matador" },
            { value: "AMC Pacer", text: "AMC Pacer" },
            { value: "AMC Rambler", text: "AMC Rambler" },
            { value: "AMC Rebel", text: "AMC Rebel" },
            { value: "AMC Spirit", text: "AMC Spirit" },
            { value: "AMC Other", text: "AMC Other" },
      ],
      Audi: [
            { value: "Audi 100", text: "Audi 100" },
            { value: "Audi 200", text: "Audi 200" },
            { value: "Audi 4000 2 & 4 Door Sedan", text: "Audi 4000 2 & 4 Door Sedan" },
            { value: "Audi 4000 Quattro", text: "Audi 4000 Quattro" },
            { value: "Audi 5000 & 5000 Quattro", text: "Audi 5000 & 5000 Quattro" },
            { value: "Audi 80 Series", text: "Audi 80 Series" },
            { value: "Audi 90 Series", text: "Audi 90 Series" },
            { value: "Audi A3", text: "Audi A3" },
            { value: "Audi A4", text: "Audi A4" },
            { value: "Audi A5", text: "Audi A5" },
            { value: "Audi A6", text: "Audi A6" },
            { value: "Audi A7", text: "Audi A7" },
            { value: "Audi A8", text: "Audi A8" },
            { value: "Audi AllRoad", text: "Audi AllRoad" },
            { value: "Audi AllRoad A4", text: "Audi AllRoad A4" },
            { value: "Audi AllRoad A6", text: "Audi AllRoad A6" },
            { value: "Audi Cabriolet", text: "Audi Cabriolet" },
            { value: "Audi Coupe GT", text: "Audi Coupe GT" },
            { value: "Audi Coupe Quattro", text: "Audi Coupe Quattro" },
            { value: "Audi E-tron", text: "Audi E-tron" },
            { value: "Audi E-tron GT", text: "Audi E-tron GT" },
            { value: "Audi E-tron S", text: "Audi E-tron S" },
            { value: "Audi Fox", text: "Audi Fox" },
            { value: "Audi Q3", text: "Audi Q3" },
            { value: "Audi Q4 E-tron", text: "Audi Q4 E-tron" },
            { value: "Audi Q5", text: "Audi Q5" },
            { value: "Audi Q7", text: "Audi Q7" },
            { value: "Audi Q8", text: "Audi Q8" },
            { value: "Audi Q8 E tron", text: "Audi Q8 E tron" },
            { value: "Audi R8", text: "Audi R8" },
            { value: "Audi RS3", text: "Audi RS3" },
            { value: "Audi RS4", text: "Audi RS4" },
            { value: "Audi RS5", text: "Audi RS5" },
            { value: "Audi RS6", text: "Audi RS6" },
            { value: "Audi RS7", text: "Audi RS7" },
            { value: "Audi RS E-tron GT", text: "Audi RS E-tron GT" },
            { value: "Audi RS Q8", text: "Audi RS Q8" },
            { value: "Audi S3", text: "Audi S3" },
            { value: "Audi S4", text: "Audi S4" },
            { value: "Audi S5", text: "Audi S5" },
            { value: "Audi S6", text: "Audi S6" },
            { value: "Audi S7", text: "Audi S7" },
            { value: "Audi S8", text: "Audi S8" },
            { value: "Audi SQ5", text: "Audi SQ5" },
            { value: "Audi SQ7", text: "Audi SQ7" },
            { value: "Audi SQ8", text: "Audi SQ8" },
            { value: "Audi SQ8 E tron", text: "Audi SQ8 E tron" },
            { value: "Audi Sport Coupe", text: "Audi Sport Coupe" },
            { value: "Audi Super 90", text: "Audi Super 90" },
            { value: "Audi TT", text: "Audi TT" },
            { value: "Audi V8 Quattro", text: "Audi V8 Quattro" },
      ],
      BMW: [
            { value: "BMW 1M", text: "BMW 1M" },
            { value: "BMW 128i", text: "BMW 128i" },
            { value: "BMW 135i", text: "BMW 135i" },
            { value: "BMW 1602", text: "BMW 1602" },
            { value: "BMW 1800", text: "BMW 1800" },
            { value: "BMW 228i", text: "BMW 228i" },
            { value: "BMW 230i", text: "BMW 230i" },
            { value: "BMW 2002", text: "BMW 2002" },
            { value: "BMW 2500", text: "BMW 2500" },
            { value: "BMW 2800", text: "BMW 2800" },
            { value: "BMW 3.0", text: "BMW 3.0" },
            { value: "BMW 318i", text: "BMW 318i" },
            { value: "BMW 320i", text: "BMW 320i" },
            { value: "BMW 323i", text: "BMW 323i" },
            { value: "BMW 325e", text: "BMW 325e" },
            { value: "BMW 325i", text: "BMW 325i" },
            { value: "BMW 328i", text: "BMW 328i" },
            { value: "BMW 328i GT", text: "BMW 328i GT" },
            { value: "BMW 330e", text: "BMW 330e" },
            { value: "BMW 330i", text: "BMW 330i" },
            { value: "BMW 330i GT", text: "BMW 330i GT" },
            { value: "BMW 335i", text: "BMW 335i" },
            { value: "BMW 335i GT", text: "BMW 335i GT" },
            { value: "BMW 340i", text: "BMW 340i" },
            { value: "BMW 340i GT", text: "BMW 340i GT" },
            { value: "BMW 428i", text: "BMW 428i" },
            { value: "BMW 430i", text: "BMW 430i" },
            { value: "BMW 435i", text: "BMW 435i" },
            { value: "BMW 440i", text: "BMW 440i" },
            { value: "BMW 524TD", text: "BMW 524TD" },
            { value: "BMW 525i", text: "BMW 525i" },
            { value: "BMW 528e", text: "BMW 528e" },
            { value: "BMW 528i", text: "BMW 528i" },
            { value: "BMW 530e", text: "BMW 530e" },
            { value: "BMW 530i", text: "BMW 530i" },
            { value: "BMW 533i", text: "BMW 533i" },
            { value: "BMW 535i", text: "BMW 535i" },
            { value: "BMW 535i GT", text: "BMW 535i GT" },
            { value: "BMW 540i", text: "BMW 540i" },
            { value: "BMW 545i", text: "BMW 545i" },
            { value: "BMW 550i", text: "BMW 550i" },
            { value: "BMW 550i GT", text: "BMW 550i GT" },
            { value: "BMW 630CSi", text: "BMW 630CSi" },
            { value: "BMW 633CSi", text: "BMW 633CSi" },
            { value: "BMW 635CSi", text: "BMW 635CSi" },
            { value: "BMW 640i", text: "BMW 640i" },
            { value: "BMW 640i GT", text: "BMW 640i GT" },
            { value: "BMW 645Ci", text: "BMW 645Ci" },
            { value: "BMW 650i", text: "BMW 650i" },
            { value: "BMW 728", text: "BMW 728" },
            { value: "BMW 732", text: "BMW 732" },
            { value: "BMW 733i", text: "BMW 733i" },
            { value: "BMW 735i", text: "BMW 735i" },
            { value: "BMW 740e", text: "BMW 740e" },
            { value: "BMW 740i", text: "BMW 740i" },
            { value: "BMW 745e", text: "BMW 745e" },
            { value: "BMW 745i", text: "BMW 745i" },
            { value: "BMW 750e", text: "BMW 750e" },
            { value: "BMW 750i", text: "BMW 750i" },
            { value: "BMW 760i", text: "BMW 760i" },
            { value: "BMW 840ci", text: "BMW 840ci" },
            { value: "BMW 840i", text: "BMW 840i" },
            { value: "BMW 850i", text: "BMW 850i" },
            { value: "BMW ActiveE", text: "BMW ActiveE" },
            { value: "BMW ActiveHybrid 3", text: "BMW ActiveHybrid 3" },
            { value: "BMW ActiveHybrid 5", text: "BMW ActiveHybrid 5" },
            { value: "BMW ActiveHybrid 7", text: "BMW ActiveHybrid 7" },
            { value: "BMW Alpina B6", text: "BMW Alpina B6" },
            { value: "BMW Alpina B7", text: "BMW Alpina B7" },
            { value: "BMW Alpina B8", text: "BMW Alpina B8" },
            { value: "BMW Alpina XB7", text: "BMW Alpina XB7" },
            { value: "BMW I3", text: "BMW I3" },
            { value: "BMW I4", text: "BMW I4" },
            { value: "BMW I5", text: "BMW I5" },
            { value: "BMW I7", text: "BMW I7" },
            { value: "BMW I8", text: "BMW I8" },
            { value: "BMW IX", text: "BMW IX" },
            { value: "BMW L6", text: "BMW L6" },
            { value: "BMW Mini Cooper", text: "BMW Mini Cooper" },
            { value: "BMW Mini Cooper Clubman", text: "BMW Mini Cooper Clubman" },
            { value: "BMW Mini Cooper Countryman", text: "BMW Mini Cooper Countryman" },
            { value: "BMW Mini Cooper Paceman", text: "BMW Mini Cooper Paceman" },
            { value: "BMW M1", text: "BMW M1" },
            { value: "BMW M2", text: "BMW M2" },
            { value: "BMW M3", text: "BMW M3" },
            { value: "BMW M4", text: "BMW M4" },
            { value: "BMW M5", text: "BMW M5" },
            { value: "BMW M6", text: "BMW M6" },
            { value: "BMW M8", text: "BMW M8" },
            { value: "BMW M235i", text: "BMW M235i" },
            { value: "BMW M240i", text: "BMW M240i" },
            { value: "BMW M340i", text: "BMW M340i" },
            { value: "BMW M440i", text: "BMW M440i" },
            { value: "BMW M550i", text: "BMW M550i" },
            { value: "BMW M760i", text: "BMW M760i" },
            { value: "BMW M850i", text: "BMW M850i" },
            { value: "BMW X1", text: "BMW X1" },
            { value: "BMW X2", text: "BMW X2" },
            { value: "BMW X3", text: "BMW X3" },
            { value: "BMW X3M", text: "BMW X3M" },
            { value: "BMW X4", text: "BMW X4" },
            { value: "BMW X4M", text: "BMW X4M" },
            { value: "BMW X5", text: "BMW X5" },
            { value: "BMW X5M", text: "BMW X5M" },
            { value: "BMW X6", text: "BMW X6" },
            { value: "BMW X6M", text: "BMW X6M" },
            { value: "BMW X7", text: "BMW X7" },
            { value: "BMW XM", text: "BMW XM" },
            { value: "BMW Z3", text: "BMW Z3" },
            { value: "BMW Z4", text: "BMW Z4" },
            { value: "BMW Z8", text: "BMW Z8" },
            { value: "BMW Other", text: "BMW Other" },
      ],
      Buick: [
            { value: "Buick Allure", text: "Buick Allure" },
            { value: "Buick Apollo", text: "Buick Apollo" },
            { value: "Buick Cascada", text: "Buick Cascada" },
            { value: "Buick Century", text: "Buick Century" },
            { value: "Buick Electra (1979 Down)", text: "Buick Electra (1979 Down)" },
            { value: "Buick Electra (1980 Up)", text: "Buick Electra (1980 Up)" },
            { value: "Buick Enclave", text: "Buick Enclave" },
            { value: "Buick Encore", text: "Buick Encore" },
            { value: "Buick Encore GX", text: "Buick Encore GX" },
            { value: "Buick Envision", text: "Buick Envision" },
            { value: "Buick Envista", text: "Buick Envista" },
            { value: "Buick Lacrosse", text: "Buick Lacrosse" },
            { value: "Buick LeSabre (1979 Down)", text: "Buick LeSabre (1979 Down)" },
            { value: "Buick LeSabre (1980 Up)", text: "Buick LeSabre (1980 Up)" },
            { value: "Buick Limited", text: "Buick Limited" },
            { value: "Buick Lucerne", text: "Buick Lucerne" },
            { value: "Buick Park Ave (1979 Down)", text: "Buick Park Ave (1979 Down)" },
            { value: "Buick Park Ave (1980 Up)", text: "Buick Park Ave (1980 Up)" },
            { value: "Buick Rainier", text: "Buick Rainier" },
            { value: "Buick Reatta", text: "Buick Reatta" },
            { value: "Buick Regal", text: "Buick Regal" },
            { value: "Buick Regal Somerset (1984 Down)", text: "Buick Regal Somerset (1984 Down)" },
            { value: "Buick Rendezvous", text: "Buick Rendezvous" },
            { value: "Buick Riviera", text: "Buick Riviera" },
            { value: "Buick Roadmaster (1979 Down)", text: "Buick Roadmaster (1979 Down)" },
            { value: "Buick Roadmaster (1980 Up)", text: "Buick Roadmaster (1980 Up)" },
            { value: "Buick Skyhawk", text: "Buick Skyhawk" },
            { value: "Buick Skylark", text: "Buick Skylark" },
            { value: "Buick Somerset (1985 Up)", text: "Buick Somerset (1985 Up)" },
            { value: "Buick Special", text: "Buick Special" },
            { value: "Buick Terraza", text: "Buick Terraza" },
            { value: "Buick Verano", text: "Buick Verano" },
            { value: "Buick Other", text: "Buick Other" },
      ],
      Cadillac: [
            { value: "Cadillac Allante", text: "Cadillac Allante" },
            { value: "Cadillac ATS", text: "Cadillac ATS" },
            { value: "Cadillac Brougham", text: "Cadillac Brougham" },
            { value: "Cadillac CT4", text: "Cadillac CT4" },
            { value: "Cadillac CT5", text: "Cadillac CT5" },
            { value: "Cadillac CT6", text: "Cadillac CT6" },
            { value: "Cadillac CTS", text: "Cadillac CTS" },
            { value: "Cadillac Catera", text: "Cadillac Catera" },
            { value: "Cadillac Cimarron", text: "Cadillac Cimarron" },
            { value: "Cadillac Concours", text: "Cadillac Concours" },
            { value: "Cadillac DeVille (1979 Down)", text: "Cadillac DeVille (1979 Down)" },
            { value: "Cadillac DeVille (1980 Up)", text: "Cadillac DeVille (1980 Up)" },
            { value: "Cadillac DHS", text: "Cadillac DHS" },
            { value: "Cadillac DTS (2005 Down)", text: "Cadillac DTS (2005 Down)" },
            { value: "Cadillac DTS (2006 Up)", text: "Cadillac DTS (2006 Up)" },
            { value: "Cadillac ELR", text: "Cadillac ELR" },
            { value: "Cadillac Eldorado (1966 Down)", text: "Cadillac Eldorado (1966 Down)" },
            { value: "Cadillac Eldorado (1967 Up)", text: "Cadillac Eldorado (1967 Up)" },
            { value: "Cadillac Escalade", text: "Cadillac Escalade" },
            { value: "Cadillac Escalade-ESV", text: "Cadillac Escalade-ESV" },
            { value: "Cadillac Escalade-EXT", text: "Cadillac Escalade-EXT" },
            { value: "Cadillac Fleetwood (1979 Down)", text: "Cadillac Fleetwood (1979 Down)" },
            { value: "Cadillac Fleetwood (1980 Up)", text: "Cadillac Fleetwood (1980 Up)" },
            { value: "Cadillac LYRIQ", text: "Cadillac LYRIQ" },
            { value: "Cadillac Seville (incl STS)", text: "Cadillac Seville (incl STS)" },
            { value: "Cadillac SRX", text: "Cadillac SRX" },
            { value: "Cadillac STS", text: "Cadillac STS" },
            { value: "Cadillac XLR", text: "Cadillac XLR" },
            { value: "Cadillac XT4", text: "Cadillac XT4" },
            { value: "Cadillac XT5", text: "Cadillac XT5" },
            { value: "Cadillac XT6", text: "Cadillac XT6" },
            { value: "Cadillac XTS", text: "Cadillac XTS" },
            { value: "Cadillac Other", text: "Cadillac Other" },
      ],
      Chevy: [
            { value: "Chevy Astra", text: "Chevy Astra" },
            { value: "Chevy Astro", text: "Chevy Astro" },
            { value: "Chevy Aveo", text: "Chevy Aveo" },
            { value: "Chevy Beretta", text: "Chevy Beretta" },
            { value: "Chevy Blazer, Full Size (1994 Down)", text: "Chevy Blazer, Full Size (1994 Down)" },
            { value: "Chevy Blazer (2019 Up)", text: "Chevy Blazer (2019 Up)" },
            { value: "Chevy Blazer EV", text: "Chevy Blazer EV" },
            { value: "Chevy Blazer, S10/S15", text: "Chevy Blazer, S10/S15" },
            { value: "Chevy Bolt", text: "Chevy Bolt" },
            { value: "Chevy Bolt EUV", text: "Chevy Bolt EUV" },
            { value: "Chevy C2", text: "Chevy C2" },
            { value: "Chevy Camaro", text: "Chevy Camaro" },
            { value: "Chevy Caprice (1979 Down)", text: "Chevy Caprice (1979 Down)" },
            { value: "Chevy Caprice (1980 Up)", text: "Chevy Caprice (1980 Up)" },
            { value: "Chevy Captiva Sport", text: "Chevy Captiva Sport" },
            { value: "Chevy Cavalier", text: "Chevy Cavalier" },
            { value: "Chevy Celebrity", text: "Chevy Celebrity" },
            { value: "Chevy Chevelle", text: "Chevy Chevelle" },
            { value: "Chevy Chevette", text: "Chevy Chevette" },
            { value: "Chevy Chevy Pickup FWD (Non US Mkt)", text: "Chevy Chevy Pickup FWD (Non US  Mkt)" },
            { value: "Chevy Chevy Small Car (Non US Mkt)", text: "Chevy Chevy Small Car (Non US Mkt)" },
            { value: "Chevy Citation", text: "Chevy Citation" },
            { value: "Chevy City Express", text: "Chevy City Express" },
            { value: "Chevy Cobalt", text: "Chevy Cobalt" },
            { value: "Chevy Corsa", text: "Chevy Corsa" },
            { value: "Chevy Corsica", text: "Chevy Corsica" },
            { value: "Chevy Corvair", text: "Chevy Corvair" },
            { value: "Chevy Corvette", text: "Chevy Corvette" },
            { value: "Chevy Cruze", text: "Chevy Cruze" },
            { value: "Chevy El Camino (1963 Down)", text: "Chevy El Camino (1963 Down)" },
            { value: "Chevy El Camino (1964-1977)", text: "Chevy El Camino (1964-1977)" },
            { value: "Chevy El Camino (1978 Up)", text: "Chevy El Camino (1978 Up)" },
            { value: "Chevy Epica", text: "Chevy Epica" },
            { value: "Chevy Equinox", text: "Chevy Equinox" },
            { value: "Chevy HHR", text: "Chevy HHR" },
            { value: "Chevy Impala (1979 Down)", text: "Chevy Impala (1979 Down)" },
            { value: "Chevy Impala (1980 Up)", text: "Chevy Impala (1980 Up)" },
            { value: "Chevy Lumina Car", text: "Chevy Lumina Car" },
            { value: "Chevy Lumina Van", text: "Chevy Lumina Van" },
            { value: "Chevy Luv (See Also Isuzu Mini P-Up)", text: "Chevy Luv (See Also Isuzu Mini  P-Up)" },
            { value: "Chevy Malibu", text: "Chevy Malibu" },
            { value: "Chevy Meriva", text: "Chevy Meriva" },
            { value: "Chevy Metro", text: "Chevy Metro" },
            { value: "Chevy Monte Carlo", text: "Chevy Monte Carlo" },
            { value: "Chevy Monza", text: "Chevy Monza" },
            { value: "Chevy Nova & Chevy II (1967 Down)", text: "Chevy Nova & Chevy II (1967 Down)" },
            { value: "Chevy Nova (1968 Up)", text: "Chevy Nova (1968 Up)" },
            { value: "Chevy Optra", text: "Chevy Optra" },
            { value: "Chevy Orlando", text: "Chevy Orlando" },
            { value: "Chevy Prizm", text: "Chevy Prizm" },
            { value: "Chevy S10/S15/Sonoma", text: "Chevy S10/S15/Sonoma" },
            { value: "Chevy Sonic", text: "Chevy Sonic" },
            { value: "Chevy Spark", text: "Chevy Spark" },
            { value: "Chevy Spectrum", text: "Chevy Spectrum" },
            { value: "Chevy Sprint", text: "Chevy Sprint" },
            { value: "Chevy SS", text: "Chevy SS" },
            { value: "Chevy SSR", text: "Chevy SSR" },
            { value: "Chevy Suburban-10 (1988 Down)", text: "Chevy Suburban-10 (1988 Down)" },
            { value: "Chevy Suburban-20 (1988 Down)", text: "Chevy Suburban-20 (1988 Down)" },
            { value: "Chevy Suburban-30 (1966 Down)", text: "Chevy Suburban-30 (1966 Down)" },
            { value: "Chevy Suburban-1000 (1963-1966)", text: "Chevy Suburban-1000 (1963-1966)" },
            { value: "Chevy Suburban-1500", text: "Chevy Suburban-1500" },
            { value: "Chevy Suburban-2500 (1967 Up)", text: "Chevy Suburban-2500 (1967 Up)" },
            { value: "Chevy Suburban-3500", text: "Chevy Suburban-3500" },
            { value: "Chevy Tahoe", text: "Chevy Tahoe" },
            { value: "Chevy Tigra", text: "Chevy Tigra" },
            { value: "Chevy Tornado", text: "Chevy Tornado" },
            { value: "Chevy Tracker", text: "Chevy Tracker" },
            { value: "Chevy TrailBlazer", text: "Chevy TrailBlazer" },
            { value: "Chevy TrailBlazer-EXT", text: "Chevy TrailBlazer-EXT" },
            { value: "Chevy Traverse", text: "Chevy Traverse" },
            { value: "Chevy Trax", text: "Chevy Trax" },
            { value: "Chevy Truck-10 Series (1987 Down)", text: "Chevy Truck-10 Series (1987 Down)" },
            { value: "Chevy Truck-20 Series (1988 Down)", text: "Chevy Truck-20 Series (1988 Down)" },
            { value: "Chevy Truck-30 Series (1988 Down)", text: "Chevy Truck-30 Series (1988 Down)" },
            { value: "Chevy Truck-1500 Series (1988-1999)", text: "Chevy Truck-1500 Series (1988-1999)" },
            { value: "Chevy Truck-2500 Series (1988-2000)", text: "Chevy Truck-2500 Series (1988-2000)" },
            { value: "Chevy Truck-3500 Series (1988-2001)", text: "Chevy Truck-3500 Series (1988-2001)" },
            { value: "Chevy Truck-Avalanche 1500", text: "Chevy Truck-Avalanche 1500" },
            { value: "Chevy Truck-Avalanche 2500", text: "Chevy Truck-Avalanche 2500" },
            { value: "Chevy Truck-C3100", text: "Chevy Truck-C3100" },
            { value: "Chevy Truck-C3600", text: "Chevy Truck-C3600" },
            { value: "Chevy Truck-C3800", text: "Chevy Truck-C3800" },
            { value: "Chevy Truck-Colorado", text: "Chevy Truck-Colorado" },
            { value: "Chevy Truck-Forward Control", text: "Chevy Truck-Forward Control" },
            { value: "Chevy Truck-Kodiak", text: "Chevy Truck-Kodiak" },
            { value: "Chevy Truck-Luv Mini Pup", text: "Chevy Truck-Luv Mini Pup" },
            { value: "Chevy Truck-S10/S15/Sonoma", text: "Chevy Truck-S10/S15/Sonoma" },
            { value: "Chevy Truck-Silverado 1500 (1999 Up)", text: "Chevy Truck-Silverado 1500 (1999 Up)" },
            { value: "Chevy Truck-Silverado 2500 (1999 Up)", text: "Chevy Truck-Silverado 2500 (1999 Up)" },
            { value: "Chevy Truck-Silverado 3500 (2001 Up)", text: "Chevy Truck-Silverado 3500 (2001 Up)" },
            { value: "Chevy Truck-Tilt Cab", text: "Chevy Truck-Tilt Cab" },
            { value: "Chevy Uplander", text: "Chevy Uplander" },
            { value: "Chevy Van 10", text: "Chevy Van 10" },
            { value: "Chevy Van 20", text: "Chevy Van 20" },
            { value: "Chevy Van 30", text: "Chevy Van 30" },
            { value: "Chevy Van Express 1500", text: "Chevy Van Express 1500" },
            { value: "Chevy Van Express 2500", text: "Chevy Van Express 2500" },
            { value: "Chevy Van Express 3500", text: "Chevy Van Express 3500" },
            { value: "Chevy Vectra", text: "Chevy Vectra" },
            { value: "Chevy Vega", text: "Chevy Vega" },
            { value: "Chevy Venture", text: "Chevy Venture" },
            { value: "Chevy Volt", text: "Chevy Volt" },
            { value: "Chevy Zafira", text: "Chevy Zafira" },
            { value: "Chevy Other", text: "Chevy Other" },
      ],
      Chrysler: [
            { value: "Chrysler 200", text: "Chrysler 200" },
            { value: "Chrysler 300", text: "Chrysler 300" },
            { value: "Chrysler 300M", text: "Chrysler 300M" },
            { value: "Chrysler Aspen", text: "Chrysler Aspen" },
            { value: "Chrysler Atos", text: "Chrysler Atos" },
            { value: "Chrysler Attitude", text: "Chrysler Attitude" },
            { value: "Chrysler Cirrus", text: "Chrysler Cirrus" },
            { value: "Chrysler Concorde", text: "Chrysler Concorde" },
            { value: "Chrysler Conquest", text: "Chrysler Conquest" },
            { value: "Chrysler Cordoba", text: "Chrysler Cordoba" },
            { value: "Chrysler Crossfire", text: "Chrysler Crossfire" },
            { value: "Chrysler E Class", text: "Chrysler E Class" },
            { value: "Chrysler Fifth Avenue - FWD", text: "Chrysler Fifth Avenue - FWD" },
            { value: "Chrysler Fifth Avenue - RWD (1979 Up)", text: "Chrysler Fifth Avenue - RWD (1979 Up)" },
            { value: "Chrysler Imperial", text: "Chrysler Imperial" },
            { value: "Chrysler LHS", text: "Chrysler LHS" },
            { value: "Chrysler Laser", text: "Chrysler Laser" },
            { value: "Chrysler Lebaron", text: "Chrysler Lebaron" },
            { value: "Chrysler New Yorker - FWD", text: "Chrysler New Yorker - FWD" },
            { value: "Chrysler New Yorker - RWD", text: "Chrysler New Yorker - RWD" },
            { value: "Chrysler Newport", text: "Chrysler Newport" },
            { value: "Chrysler Pacifica", text: "Chrysler Pacifica" },
            { value: "Chrysler Prowler", text: "Chrysler Prowler" },
            { value: "Chrysler PT Cruiser", text: "Chrysler PT Cruiser" },
            { value: "Chrysler Sebring", text: "Chrysler Sebring" },
            { value: "Chrysler TC", text: "Chrysler TC" },
            { value: "Chrysler Town and Country", text: "Chrysler Town and Country" },
            { value: "Chrysler Voyager", text: "Chrysler Voyager" },
            { value: "Chrysler Other", text: "Chrysler Other" },
      ],
      Daewoo: [
            { value: "Daewoo Lanos", text: "Daewoo Lanos" },
            { value: "Daewoo Leganza", text: "Daewoo Leganza" },
            { value: "Daewoo Nubira", text: "Daewoo Nubira" },
      ],
      Daihatsu: [
            { value: "Daihatsu Charade", text: "Daihatsu Charade" },
            { value: "Daihatsu Hijet", text: "Daihatsu Hijet" },
            { value: "Daihatsu Rocky", text: "Daihatsu Rocky" },
      ],
      Dodge: [
            { value: "Dodge 400", text: "Dodge 400" },
            { value: "Dodge 600", text: "Dodge 600" },
            { value: "Dodge Aries", text: "Dodge Aries" },
            { value: "Dodge Aspen", text: "Dodge Aspen" },
            { value: "Dodge Avenger", text: "Dodge Avenger" },
            { value: "Dodge Caliber", text: "Dodge Caliber" },
            { value: "Dodge Caravan", text: "Dodge Caravan" },
            { value: "Dodge Challenger (Chrysler)", text: "Dodge Challenger (Chrysler)" },
            { value: "Dodge Challenger (Mitsubishi)", text: "Dodge Challenger (Mitsubishi)" },
            { value: "Dodge Charger", text: "Dodge Charger" },
            { value: "Dodge Colt-not Vista", text: "Dodge Colt-not Vista" },
            { value: "Dodge Colt Vista", text: "Dodge Colt Vista" },
            { value: "Dodge Cricket", text: "Dodge Cricket" },
            { value: "Dodge D50/Ram 50 (See also Plymouth Arrow Truck)", text: "Dodge D50/Ram 50 (See also Plymouth Arrow Truck)" },
            { value: "Dodge Dakota", text: "Dodge Dakota" },
            { value: "Dodge Dart", text: "Dodge Dart" },
            { value: "Dodge Daytona", text: "Dodge Daytona" },
            { value: "Dodge Diplomat", text: "Dodge Diplomat" },
            { value: "Dodge Durango", text: "Dodge Durango" },
            { value: "Dodge Dynasty", text: "Dodge Dynasty" },
            { value: "Dodge Hornet", text: "Dodge Hornet" },
            { value: "Dodge Intrepid", text: "Dodge Intrepid" },
            { value: "Dodge Journey", text: "Dodge Journey" },
            { value: "Dodge Lancer", text: "Dodge Lancer" },
            { value: "Dodge Magnum", text: "Dodge Magnum" },
            { value: "Dodge Mirada", text: "Dodge Mirada" },
            { value: "Dodge Monaco (1978 Down)", text: "Dodge Monaco (1978 Down)" },
            { value: "Dodge Monaco (1990 Up)", text: "Dodge Monaco (1990 Up)" },
            { value: "Dodge Neon", text: "Dodge Neon" },
            { value: "Dodge Nitro", text: "Dodge Nitro" },
            { value: "Dodge Omni", text: "Dodge Omni" },
            { value: "Dodge Raider", text: "Dodge Raider" },
            { value: "Dodge Ramcharger", text: "Dodge Ramcharger" },
            { value: "Dodge Rampage", text: "Dodge Rampage" },
            { value: "Dodge Shadow", text: "Dodge Shadow" },
            { value: "Dodge Spirit", text: "Dodge Spirit" },
            { value: "Dodge St Regis", text: "Dodge St Regis" },
            { value: "Dodge Stealth", text: "Dodge Stealth" },
            { value: "Dodge Stratus", text: "Dodge Stratus" },
            { value: "Dodge Truck-100 Series (1989 Down)", text: "Dodge Truck-100 Series (1989 Down)" },
            { value: "Dodge Truck-200 Series (1980 Down)", text: "Dodge Truck-200 Series (1980 Down)" },
            { value: "Dodge Truck-300 Series (1980 Down)", text: "Dodge Truck-300 Series (1980 Down)" },
            { value: "Dodge Truck-400 Series", text: "Dodge Truck-400 Series" },
            { value: "Dodge Truck-150 (1978-1993)", text: "Dodge Truck-150 (1978-1993)" },
            { value: "Dodge Truck-250 Series (1981-1993)", text: "Dodge Truck-250 Series (1981-1993)" },
            { value: "Dodge Truck-350 Series (1981-1993)", text: "Dodge Truck-350 Series (1981-1993)" },
            { value: "Dodge Truck-450 Series", text: "Dodge Truck-450 Series" },
            { value: "Dodge Truck-1500 (1994 Up)", text: "Dodge Truck-1500 (1994 Up)" },
            { value: "Dodge Truck-2500 Series (1994 Up)", text: "Dodge Truck-2500 Series (1994 Up)" },
            { value: "Dodge Truck-3500 (1994 Up)", text: "Dodge Truck-3500 (1994 Up)" },
            { value: "Dodge Truck-4500 Series", text: "Dodge Truck-4500 Series" },
            { value: "Dodge Truck-5500 Series", text: "Dodge Truck-5500 Series" },
            { value: "Dodge Truck-D50/Ram 50", text: "Dodge Truck-D50/Ram 50" },
            { value: "Dodge Truck-Dakota", text: "Dodge Truck-Dakota" },
            { value: "Dodge Truck-Forward Control", text: "Dodge Truck-Forward Control" },
            { value: "Dodge Truck-Rampage", text: "Dodge Truck-Rampage" },
            { value: "Dodge Van 100", text: "Dodge Van 100" },
            { value: "Dodge Van 150", text: "Dodge Van 150" },
            { value: "Dodge Van 200", text: "Dodge Van 200" },
            { value: "Dodge Van 250", text: "Dodge Van 250" },
            { value: "Dodge Van 300", text: "Dodge Van 300" },
            { value: "Dodge Van 350", text: "Dodge Van 350" },
            { value: "Dodge Van 1500", text: "Dodge Van 1500" },
            { value: "Dodge Van 2500", text: "Dodge Van 2500" },
            { value: "Dodge Van 3500", text: "Dodge Van 3500" },
            { value: "Dodge Van (Sprinter 2500)", text: "Dodge Van (Sprinter 2500)" },
            { value: "Dodge Van (Sprinter 3500)", text: "Dodge Van (Sprinter 3500)" },
            { value: "Dodge Verna", text: "Dodge Verna" },
            { value: "Dodge Viper", text: "Dodge Viper" },
            { value: "Dodge Other", text: "Dodge Other" },
      ],
      Eagle: [
            { value: "Eagle 2000 GTX", text: "Eagle 2000 GTX" },
            { value: "Eagle Premier", text: "Eagle Premier" },
            { value: "Eagle Summit", text: "Eagle Summit" },
            { value: "Eagle Talon", text: "Eagle Talon" },
            { value: "Eagle Vision", text: "Eagle Vision" },
      ],
      Fiat: [
            { value: "Fiat 1100R", text: "Fiat 1100R" },
            { value: "Fiat 124 (1983 Down, includes Spider)", text: "Fiat 124 (1983 Down, includes Spider)" },
            { value: "Fiat 124 Spider (2016 Up)", text: "Fiat 124 Spider (2016 Up)" },
            { value: "Fiat 128", text: "Fiat 128" },
            { value: "Fiat 131/Brava", text: "Fiat 131/Brava" },
            { value: "Fiat 500", text: "Fiat 500" },
            { value: "Fiat 600", text: "Fiat 600" },
            { value: "Fiat 850", text: "Fiat 850" },
            { value: "Fiat Spider (includes 2000)", text: "Fiat Spider (includes 2000)" },
            { value: "Fiat Strada", text: "Fiat Strada" },
            { value: "Fiat X 1/9", text: "Fiat X 1/9" },
            { value: "Fiat Other", text: "Fiat Other" },
      ],
      Ford: [
            { value: "Ford 500", text: "Ford 500" },
            { value: "Ford Aerostar", text: "Ford Aerostar" },
            { value: "Ford Aspire", text: "Ford Aspire" },
            { value: "Ford Bronco (Full Size)", text: "Ford Bronco (Full Size)" },
            { value: "Ford Bronco II", text: "Ford Bronco II" },
            { value: "Ford Bronco Raptor", text: "Ford Bronco Raptor" },
            { value: "Ford Bronco Sport", text: "Ford Bronco Sport" },
            { value: "Ford C-Max", text: "Ford C-Max" },
            { value: "Ford Contour", text: "Ford Contour" },
            { value: "Ford Cortina", text: "Ford Cortina" },
            { value: "Ford Courier", text: "Ford Courier" },
            { value: "Ford Crown Vic (1982 Down)", text: "Ford Crown Vic (1982 Down)" },
            { value: "Ford Crown Vic (1983 Up)", text: "Ford Crown Vic (1983 Up)" },
            { value: "Ford E Transit", text: "Ford E Transit" },
            { value: "Ford Ecosport", text: "Ford Ecosport" },
            { value: "Ford Edge", text: "Ford Edge" },
            { value: "Ford Escape", text: "Ford Escape" },
            { value: "Ford Escort", text: "Ford Escort" },
            { value: "Ford Excursion", text: "Ford Excursion" },
            { value: "Ford EXP", text: "Ford EXP" },
            { value: "Ford Expedition", text: "Ford Expedition" },
            { value: "Ford Explorer", text: "Ford Explorer" },
            { value: "Ford Fairlane", text: "Ford Fairlane" },
            { value: "Ford Fairmont", text: "Ford Fairmont" },
            { value: "Ford Falcon", text: "Ford Falcon" },
            { value: "Ford Festiva", text: "Ford Festiva" },
            { value: "Ford Fiesta", text: "Ford Fiesta" },
            { value: "Ford Five Hundred", text: "Ford Five Hundred" },
            { value: "Ford Flex", text: "Ford Flex" },
            { value: "Ford Focus", text: "Ford Focus" },
            { value: "Ford Focus RS", text: "Ford Focus RS" },
            { value: "Ford Freestar", text: "Ford Freestar" },
            { value: "Ford Freestyle", text: "Ford Freestyle" },
            { value: "Ford Fusion", text: "Ford Fusion" },
            { value: "Ford Galaxie", text: "Ford Galaxie" },
            { value: "Ford Granada", text: "Ford Granada" },
            { value: "Ford GT", text: "Ford GT" },
            { value: "Ford Ikon", text: "Ford Ikon" },
            { value: "Ford KA", text: "Ford KA" },
            { value: "Ford LTD (1978 Down)", text: "Ford LTD (1978 Down)" },
            { value: "Ford LTD (1979 Up)", text: "Ford LTD (1979 Up)" },
            { value: "Ford LTD II", text: "Ford LTD II" },
            { value: "Ford Maverick", text: "Ford Maverick" },
            { value: "Ford Maverick Pickup", text: "Ford Maverick Pickup" },
            { value: "Ford Mondeo", text: "Ford Mondeo" },
            { value: "Ford Mustang", text: "Ford Mustang" },
            { value: "Ford Mustang Mach E", text: "Ford Mustang Mach E" },
            { value: "Ford Pinto", text: "Ford Pinto" },
            { value: "Ford Probe", text: "Ford Probe" },
            { value: "Ford Ranchero (1967-1970)", text: "Ford Ranchero (1967-1970)" },
            { value: "Ford Ranchero (1971-1976)", text: "Ford Ranchero (1971-1976)" },
            { value: "Ford Ranchero (1977 up)", text: "Ford Ranchero (1977 up)" },
            { value: "Ford Ranchero (1957-1959)", text: "Ford Ranchero (1957-1959)" },
            { value: "Ford Ranchero (1960-1966)", text: "Ford Ranchero (1960-1966)" },
            { value: "Ford Ranger", text: "Ford Ranger" },
            { value: "Ford Ranger Raptor", text: "Ford Ranger Raptor" },
            { value: "Ford Taurus", text: "Ford Taurus" },
            { value: "Ford Taurus X", text: "Ford Taurus X" },
            { value: "Ford Tempo", text: "Ford Tempo" },
            { value: "Ford ThinkCity-Electric", text: "Ford ThinkCity-Electric" },
            { value: "Ford Thunderbird", text: "Ford Thunderbird" },
            { value: "Ford Torino", text: "Ford Torino" },
            { value: "Ford Transit 150", text: "Ford Transit 150" },
            { value: "Ford Transit 250", text: "Ford Transit 250" },
            { value: "Ford Transit 350", text: "Ford Transit 350" },
            { value: "Ford Transit Connect", text: "Ford Transit Connect" },
            { value: "Ford Truck-Courier", text: "Ford Truck-Courier" },
            { value: "Ford Truck-F100", text: "Ford Truck-F100" },
            { value: "Ford Truck-F150", text: "Ford Truck-F150" },
            { value: "Ford Truck F150 Lightning (Electric)", text: "Ford Truck F150 Lightning (Electric)" },
            { value: "Ford Truck-F150 Lightning (SVT Gas)", text: "Ford Truck-F150 Lightning (SVT Gas)" },
            { value: "Ford Truck-F150 Raptor", text: "Ford Truck-F150 Raptor" },
            { value: "Ford Truck-F250 not Super Duty (1999 Down)", text: "Ford Truck-F250 not Super Duty (1999 Down)" },
            { value: "Ford Truck-F250 Super Duty (1999 Up)", text: "Ford Truck-F250 Super Duty (1999 Up)" },
            { value: "Ford Truck-F350 not Super Duty (1997 Down)", text: "Ford Truck-F350 not Super Duty (1997 Down)" },
            { value: "Ford Truck-F350 Super Duty (1999 Up)", text: "Ford Truck-F350 Super Duty (1999 Up)" },
            { value: "Ford Truck-F450 not Super Duty (1997 Down)", text: "Ford Truck-F450 not Super Duty (1997 Down)" },
            { value: "Ford Truck-F450 Super Duty (1999 Up)", text: "Ford Truck-F450 Super Duty (1999 Up)" },
            { value: "Ford Truck-F550 Super Duty (1999 Up)", text: "Ford Truck-F550 Super Duty (1999 Up)" },
            { value: "Ford Truck-Forward Control", text: "Ford Truck-Forward Control" },
            { value: "Ford Truck-Ranger", text: "Ford Truck-Ranger" },
            { value: "Ford Van E100", text: "Ford Van E100" },
            { value: "Ford Van E150", text: "Ford Van E150" },
            { value: "Ford Van E200", text: "Ford Van E200" },
            { value: "Ford Van E250", text: "Ford Van E250" },
            { value: "Ford Van E300", text: "Ford Van E300" },
            { value: "Ford Van E350", text: "Ford Van E350" },
            { value: "Ford Van E450 Super Duty", text: "Ford Van E450 Super Duty" },
            { value: "Ford Van E550 Super Duty", text: "Ford Van E550 Super Duty" },
            { value: "Ford Windstar", text: "Ford Windstar" },
            { value: "Ford Other", text: "Ford Other" },
      ],
      Geo: [
            { value: "Geo Metro", text: "Geo Metro" },
            { value: "Geo Prizm", text: "Geo Prizm" },
            { value: "Geo Spectrum", text: "Geo Spectrum" },
            { value: "Geo Storm", text: "Geo Storm" },
            { value: "Geo Tracker", text: "Geo Tracker" },
      ],
      GMC: [
            { value: "GMC Acadia", text: "GMC Acadia" },
            { value: "GMC Hummer EV", text: "GMC Hummer EV" },
            { value: "GMC Jimmy, Full Size", text: "GMC Jimmy, Full Size" },
            { value: "GMC Jimmy, S10/S15", text: "GMC Jimmy, S10/S15" },
            { value: "GMC Safari Van", text: "GMC Safari Van" },
            { value: "GMC Sprint", text: "GMC Sprint" },
            { value: "GMC Suburban-10 (1988 Down)", text: "GMC Suburban-10 (1988 Down)" },
            { value: "GMC Suburban-20 (1988 Down)", text: "GMC Suburban-20 (1988 Down)" },
            { value: "GMC Suburban-30 (1965-1966)", text: "GMC Suburban-30 (1965-1966)" },
            { value: "GMC Suburban-1000 (1965-1966)", text: "GMC Suburban-1000 (1965-1966)" },
            { value: "GMC Suburban-1500 (2001 Down)", text: "GMC Suburban-1500 (2001 Down)" },
            { value: "GMC Suburban-2500 (1967 Up)", text: "GMC Suburban-2500 (1967 Up)" },
            { value: "GMC Syclone", text: "GMC Syclone" },
            { value: "GMC Terrain", text: "GMC Terrain" },
            { value: "GMC Truck-1000 Series (1966 Down)", text: "GMC Truck-1000 Series (1966 Down)" },
            { value: "GMC Truck-1500 Series (1999 Down)", text: "GMC Truck-1500 Series (1999 Down)" },
            { value: "GMC Truck-2500 Series (2000 Down)", text: "GMC Truck-2500 Series (2000 Down)" },
            { value: "GMC Truck-3500 Series (2001 Down)", text: "GMC Truck-3500 Series (2001 Down)" },
            { value: "GMC Truck-Canyon", text: "GMC Truck-Canyon" },
            { value: "GMC Truck-Envoy", text: "GMC Truck-Envoy" },
            { value: "GMC Truck-Envoy XL", text: "GMC Truck-Envoy XL" },
            { value: "GMC Truck-Envoy XUV", text: "GMC Truck-Envoy XUV" },
            { value: "GMC Truck-Forward Control", text: "GMC Truck-Forward Control" },
            { value: "GMC Truck-S10/S15/Sonoma", text: "GMC Truck-S10/S15/Sonoma" },
            { value: "GMC Truck-Sierra 1500 (1999 Up)", text: "GMC Truck-Sierra 1500 (1999 Up)" },
            { value: "GMC Truck-Sierra 2500 (1999 Up)", text: "GMC Truck-Sierra 2500 (1999 Up)" },
            { value: "GMC Truck-Sierra 3500 (2001 Up)", text: "GMC Truck-Sierra 3500 (2001 Up)" },
            { value: "GMC Truck-Sierra Denali", text: "GMC Truck-Sierra Denali" },
            { value: "GMC Truck-Sierra Denali 1500 (2011 Up)", text: "GMC Truck-Sierra Denali 1500 (2011 Up)" },
            { value: "GMC Truck-Sierra Denali 2500 (2011 Up)", text: "GMC Truck-Sierra Denali 2500 (2011 Up)" },
            { value: "GMC Truck-Sierra Denali 3500 (2011 Up)", text: "GMC Truck-Sierra Denali 3500 (2011 Up)" },
            { value: "GMC Truck-Topkick", text: "GMC Truck-Topkick" },
            { value: "GMC Truck-Yukon (except XL)", text: "GMC Truck-Yukon (except XL)" },
            { value: "GMC Truck-Yukon XL1500", text: "GMC Truck-Yukon XL1500" },
            { value: "GMC Truck-Yukon XL2500", text: "GMC Truck-Yukon XL2500" },
            { value: "GMC Typhoon", text: "GMC Typhoon" },
            { value: "GMC Van 1000", text: "GMC Van 1000" },
            { value: "GMC Van 1500", text: "GMC Van 1500" },
            { value: "GMC Van 2500", text: "GMC Van 2500" },
            { value: "GMC Van 3500", text: "GMC Van 3500" },
            { value: "GMC Van Savana 1500", text: "GMC Van Savana 1500" },
            { value: "GMC Van Savana 2500", text: "GMC Van Savana 2500" },
            { value: "GMC Van Savana 3500", text: "GMC Van Savana 3500" },
      ],
      Honda: [
            { value: "Honda 600", text: "Honda 600" },
            { value: "Honda Accord", text: "Honda Accord" },
            { value: "Honda Acty", text: "Honda Acty" },
            { value: "Honda Civic", text: "Honda Civic" },
            { value: "Honda Clarity", text: "Honda Clarity" },
            { value: "Honda Clarity Electric", text: "Honda Clarity Electric" },
            { value: "Honda Clarity Fuel Cell", text: "Honda Clarity Fuel Cell" },
            { value: "Honda Crosstour", text: "Honda Crosstour" },
            { value: "Honda CRV", text: "Honda CRV" },
            { value: "Honda CRX", text: "Honda CRX" },
            { value: "Honda CRZ", text: "Honda CRZ" },
            { value: "Honda DelSol", text: "Honda DelSol" },
            { value: "Honda Element", text: "Honda Element" },
            { value: "Honda FCX", text: "Honda FCX" },
            { value: "Honda Fit", text: "Honda Fit" },
            { value: "Honda HRV", text: "Honda HRV" },
            { value: "Honda Insight", text: "Honda Insight" },
            { value: "Honda Odyssey", text: "Honda Odyssey" },
            { value: "Honda Passport", text: "Honda Passport" },
            { value: "Honda Pilot", text: "Honda Pilot" },
            { value: "Honda Prelude", text: "Honda Prelude" },
            { value: "Honda Prologue", text: "Honda Prologue" },
            { value: "Honda Ridgeline", text: "Honda Ridgeline" },
            { value: "Honda S2000", text: "Honda S2000" },
      ],
      Hummer: [
            { value: "Hummer", text: "Hummer" },
            { value: "Hummer H1", text: "Hummer H1" },
            { value: "Hummer H2", text: "Hummer H2" },
            { value: "Hummer H3", text: "Hummer H3" },
      ],
      Hyundai: [
            { value: "Hyundai Accent", text: "Hyundai Accent" },
            { value: "Hyundai Azera", text: "Hyundai Azera" },
            { value: "Hyundai Elantra", text: "Hyundai Elantra" },
            { value: "Hyundai Entourage", text: "Hyundai Entourage" },
            { value: "Hyundai Equus", text: "Hyundai Equus" },
            { value: "Hyundai Excel", text: "Hyundai Excel" },
            { value: "Hyundai Genesis", text: "Hyundai Genesis" },
            { value: "Hyundai Ioniq", text: "Hyundai Ioniq" },
            { value: "Hyundai Ioniq 5", text: "Hyundai Ioniq 5" },
            { value: "Hyundai Ioniq 6", text: "Hyundai Ioniq 6" },
            { value: "Hyundai Kona", text: "Hyundai Kona" },
            { value: "Hyundai Kona Electric", text: "Hyundai Kona Electric" },
            { value: "Hyundai Nexo", text: "Hyundai Nexo" },
            { value: "Hyundai Palisade", text: "Hyundai Palisade" },
            { value: "Hyundai Pony", text: "Hyundai Pony" },
            { value: "Hyundai Santa Cruz", text: "Hyundai Santa Cruz" },
            { value: "Hyundai Santa Fe", text: "Hyundai Santa Fe" },
            { value: "Hyundai Scoupe", text: "Hyundai Scoupe" },
            { value: "Hyundai Sonata", text: "Hyundai Sonata" },
            { value: "Hyundai Stellar", text: "Hyundai Stellar" },
            { value: "Hyundai Tiburon", text: "Hyundai Tiburon" },
            { value: "Hyundai Tucson", text: "Hyundai Tucson" },
            { value: "Hyundai Veloster", text: "Hyundai Veloster" },
            { value: "Hyundai Venue", text: "Hyundai Venue" },
            { value: "Hyundai Veracruz", text: "Hyundai Veracruz" },
            { value: "Hyundai XG Series", text: "Hyundai XG Series" },
      ],
      Infiniti: [
            { value: "Infiniti EX35", text: "Infiniti EX35" },
            { value: "Infiniti EX37", text: "Infiniti EX37" },
            { value: "Infiniti FX", text: "Infiniti FX" },
            { value: "Infiniti G20", text: "Infiniti G20" },
            { value: "Infiniti G25", text: "Infiniti G25" },
            { value: "Infiniti G35", text: "Infiniti G35" },
            { value: "Infiniti G37", text: "Infiniti G37" },
            { value: "Infiniti I30", text: "Infiniti I30" },
            { value: "Infiniti I35", text: "Infiniti I35" },
            { value: "Infiniti J30", text: "Infiniti J30" },
            { value: "Infiniti JX35", text: "Infiniti JX35" },
            { value: "Infiniti M30", text: "Infiniti M30" },
            { value: "Infiniti M35", text: "Infiniti M35" },
            { value: "Infiniti M37", text: "Infiniti M37" },
            { value: "Infiniti M45", text: "Infiniti M45" },
            { value: "Infiniti M56", text: "Infiniti M56" },
            { value: "Infiniti Q40", text: "Infiniti Q40" },
            { value: "Infiniti Q45", text: "Infiniti Q45" },
            { value: "Infiniti Q50", text: "Infiniti Q50" },
            { value: "Infiniti Q60", text: "Infiniti Q60" },
            { value: "Infiniti Q70", text: "Infiniti Q70" },
            { value: "Infiniti QX4", text: "Infiniti QX4" },
            { value: "Infiniti QX30", text: "Infiniti QX30" },
            { value: "Infiniti QX50", text: "Infiniti QX50" },
            { value: "Infiniti QX55", text: "Infiniti QX55" },
            { value: "Infiniti QX56", text: "Infiniti QX56" },
            { value: "Infiniti QX60", text: "Infiniti QX60" },
            { value: "Infiniti QX70", text: "Infiniti QX70" },
            { value: "Infiniti QX80", text: "Infiniti QX80" },
      ],
      Isuzu: [
            { value: "Isuzu Amigo", text: "Isuzu Amigo" },
            { value: "Isuzu Ascender", text: "Isuzu Ascender" },
            { value: "Isuzu Axiom", text: "Isuzu Axiom" },
            { value: "Isuzu Gemini", text: "Isuzu Gemini" },
            { value: "Isuzu IMark", text: "Isuzu IMark" },
            { value: "Isuzu Impulse", text: "Isuzu Impulse" },
            { value: "Isuzu Oasis", text: "Isuzu Oasis" },
            { value: "Isuzu Optima", text: "Isuzu Optima" },
            { value: "Isuzu Reach", text: "Isuzu Reach" },
            { value: "Isuzu Rodeo", text: "Isuzu Rodeo" },
            { value: "Isuzu Stylus", text: "Isuzu Stylus" },
            { value: "Isuzu Trooper/Trooper II", text: "Isuzu Trooper/Trooper II" },
            { value: "Isuzu Truck (Big)", text: "Isuzu Truck (Big)" },
            { value: "Isuzu Truck-(Mini Pickup)", text: "Isuzu Truck-(Mini Pickup)" },
            { value: "Isuzu Truck-(Mini Pickup) Hombre", text: "Isuzu Truck-(Mini Pickup) Hombre" },
            { value: "Isuzu Truck i280 (Pickup)", text: "Isuzu Truck i280 (Pickup)" },
            { value: "Isuzu Truck i290 (Pickup)", text: "Isuzu Truck i290 (Pickup)" },
            { value: "Isuzu Truck i350 (Pickup)", text: "Isuzu Truck i350 (Pickup)" },
            { value: "Isuzu Truck i370 (Pickup)", text: "Isuzu Truck i370 (Pickup)" },
            { value: "Isuzu Vehicross", text: "Isuzu Vehicross" },
      ],
      Jaguar: [
            { value: "Jaguar 120", text: "Jaguar 120" },
            { value: "Jaguar 140", text: "Jaguar 140" },
            { value: "Jaguar 150", text: "Jaguar 150" },
            { value: "Jaguar E Pace", text: "Jaguar E Pace" },
            { value: "Jaguar F Pace", text: "Jaguar F Pace" },
            { value: "Jaguar F Type", text: "Jaguar F Type" },
            { value: "Jaguar I Pace", text: "Jaguar I Pace" },
            { value: "Jaguar Mark 10", text: "Jaguar Mark 10" },
            { value: "Jaguar S Type", text: "Jaguar S Type" },
            { value: "Jaguar Sedan", text: "Jaguar Sedan" },
            { value: "Jaguar Vanden Plas (1997 Down)", text: "Jaguar Vanden Plas (1997 Down)" },
            { value: "Jaguar Vanden Plas (1998 to 2007)", text: "Jaguar Vanden Plas (1998 to 2007)" },
            { value: "Jaguar Vanden Plas (2008 Up)", text: "Jaguar Vanden Plas (2008 Up)" },
            { value: "Jaguar X Type", text: "Jaguar X Type" },
            { value: "Jaguar XE", text: "Jaguar XE" },
            { value: "Jaguar XF", text: "Jaguar XF" },
            { value: "Jaguar XF Sportbrake", text: "Jaguar XF Sportbrake" },
            { value: "Jaguar XJ Series (2008 Up)", text: "Jaguar XJ Series (2008 Up)" },
            { value: "Jaguar XJR (1993)", text: "Jaguar XJR (1993)" },
            { value: "Jaguar XJR (1995 to 1997)", text: "Jaguar XJR (1995 to 1997)" },
            { value: "Jaguar XJR (1998 to 2007)", text: "Jaguar XJR (1998 to 2007)" },
            { value: "Jaguar XJR (2008 Up)", text: "Jaguar XJR (2008 Up)" },
            { value: "Jaguar XJS", text: "Jaguar XJS" },
            { value: "Jaguar XJ6", text: "Jaguar XJ6" },
            { value: "Jaguar XJ8 (2008 Up)", text: "Jaguar XJ8 (2008 Up)" },
            { value: "Jaguar XJ8 (2007 Down)", text: "Jaguar XJ8 (2007 Down)" },
            { value: "Jaguar XJ12", text: "Jaguar XJ12" },
            { value: "Jaguar XK Series (2007 Up)", text: "Jaguar XK Series (2007 Up)" },
            { value: "Jaguar XKE", text: "Jaguar XKE" },
            { value: "Jaguar XKR (2006 Down)", text: "Jaguar XKR (2006 Down)" },
            { value: "Jaguar XKR (2007 Up)", text: "Jaguar XKR (2007 Up)" },
            { value: "Jaguar XK8", text: "Jaguar XK8" },
      ],
      Jeep: [
            { value: "Jeep Cherokee (except Grand Cherokee)", text: "Jeep Cherokee (except Grand Cherokee)" },
            { value: "Jeep CJSeries", text: "Jeep CJSeries" },
            { value: "Jeep Comanche", text: "Jeep Comanche" },
            { value: "Jeep Commander", text: "Jeep Commander" },
            { value: "Jeep Compass", text: "Jeep Compass" },
            { value: "Jeep DJ Series", text: "Jeep DJ Series" },
            { value: "Jeep FC Series", text: "Jeep FC Series" },
            { value: "Jeep Gladiator", text: "Jeep Gladiator" },
            { value: "Jeep Grand Cherokee", text: "Jeep Grand Cherokee" },
            { value: "Jeep Grand Wagoneer", text: "Jeep Grand Wagoneer" },
            { value: "Jeep J-Series", text: "Jeep J-Series" },
            { value: "Jeep Jeepster", text: "Jeep Jeepster" },
            { value: "Jeep Liberty", text: "Jeep Liberty" },
            { value: "Jeep Patriot", text: "Jeep Patriot" },
            { value: "Jeep Renegade", text: "Jeep Renegade" },
            { value: "Jeep Station Wagon", text: "Jeep Station Wagon" },
            { value: "Jeep Truck", text: "Jeep Truck" },
            { value: "Jeep Wagoneer (except Grand Wagoneer)", text: "Jeep Wagoneer (except Grand Wagoneer)" },
            { value: "Jeep Wrangler", text: "Jeep Wrangler" },
      ],
      Kia: [
            { value: "Kia Amanti", text: "Kia Amanti" },
            { value: "Kia Besta", text: "Kia Besta" },
            { value: "Kia Borrego", text: "Kia Borrego" },
            { value: "Kia Cadenza", text: "Kia Cadenza" },
            { value: "Kia Carnival", text: "Kia Carnival" },
            { value: "Kia EV6", text: "Kia EV6" },
            { value: "Kia EV9", text: "Kia EV9" },
            { value: "Kia Forte", text: "Kia Forte" },
            { value: "Kia K5", text: "Kia K5" },
            { value: "Kia K900", text: "Kia K900" },
            { value: "Kia Magentis", text: "Kia Magentis" },
            { value: "Kia Niro", text: "Kia Niro" },
            { value: "Kia Niro EV", text: "Kia Niro EV" },
            { value: "Kia Optima", text: "Kia Optima" },
            { value: "Kia Rio", text: "Kia Rio" },
            { value: "Kia Rondo", text: "Kia Rondo" },
            { value: "Kia Sedona", text: "Kia Sedona" },
            { value: "Kia Seltos", text: "Kia Seltos" },
            { value: "Kia Sephia", text: "Kia Sephia" },
            { value: "Kia Sorento", text: "Kia Sorento" },
            { value: "Kia Soul", text: "Kia Soul" },
            { value: "Kia Spectra", text: "Kia Spectra" },
            { value: "Kia Sportage", text: "Kia Sportage" },
            { value: "Kia Stinger", text: "Kia Stinger" },
            { value: "Kia Telluride", text: "Kia Telluride" },
      ],
      LandRover: [
            { value: "LandRover Defender (1997 Down)", text: "LandRover Defender (1997 Down)" },
            { value: "LandRover Defender (2020 Up)", text: "LandRover Defender (2020 Up)" },
            { value: "LandRover Discovery (2004 Down)", text: "LandRover Discovery (2004 Down)" },
            { value: "LandRover Discovery (2017 Up)", text: "LandRover Discovery (2017 Up)" },
            { value: "LandRover Discovery Sport", text: "LandRover Discovery Sport" },
            { value: "LandRover Freelander", text: "LandRover Freelander" },
            { value: "LandRover LR2", text: "LandRover LR2" },
            { value: "LandRover LR3", text: "LandRover LR3" },
            { value: "LandRover LR4", text: "LandRover LR4" },
            { value: "LandRover Range Rover", text: "LandRover Range Rover" },
            { value: "LandRover Range Rover Evoque", text: "LandRover Range Rover Evoque" },
            { value: "LandRover Range Rover Sport", text: "LandRover Range Rover Sport" },
            { value: "LandRover Range Rover Velar", text: "LandRover Range Rover Velar" },
            { value: "LandRover Other", text: "LandRover Other" },
      ],
      Lexus: [
            { value: "Lexus CT 200H", text: "Lexus CT 200H" },
            { value: "Lexus ES250", text: "Lexus ES250" },
            { value: "Lexus ES300", text: "Lexus ES300" },
            { value: "Lexus ES300H", text: "Lexus ES300H" },
            { value: "Lexus ES330", text: "Lexus ES330" },
            { value: "Lexus ES350", text: "Lexus ES350" },
            { value: "Lexus GS200t", text: "Lexus GS200t" },
            { value: "Lexus GS300", text: "Lexus GS300" },
            { value: "Lexus GS350", text: "Lexus GS350" },
            { value: "Lexus GS400", text: "Lexus GS400" },
            { value: "Lexus GS430", text: "Lexus GS430" },
            { value: "Lexus GS450h", text: "Lexus GS450h" },
            { value: "Lexus GS460", text: "Lexus GS460" },
            { value: "Lexus GS F", text: "Lexus GS F" },
            { value: "Lexus GX460", text: "Lexus GX460" },
            { value: "Lexus GX470", text: "Lexus GX470" },
            { value: "Lexus GX550", text: "Lexus GX550" },
            { value: "Lexus HS250H", text: "Lexus HS250H" },
            { value: "Lexus IS200t", text: "Lexus IS200t" },
            { value: "Lexus IS250", text: "Lexus IS250" },
            { value: "Lexus IS300", text: "Lexus IS300" },
            { value: "Lexus IS350", text: "Lexus IS350" },
            { value: "Lexus IS500", text: "Lexus IS500" },
            { value: "Lexus IS F", text: "Lexus IS F" },
            { value: "Lexus LC500", text: "Lexus LC500" },
            { value: "Lexus LC500h", text: "Lexus LC500h" },
            { value: "Lexus LFA", text: "Lexus LFA" },
            { value: "Lexus LS400", text: "Lexus LS400" },
            { value: "Lexus LS430", text: "Lexus LS430" },
            { value: "Lexus LS460", text: "Lexus LS460" },
            { value: "Lexus LS500", text: "Lexus LS500" },
            { value: "Lexus LS500h", text: "Lexus LS500h" },
            { value: "Lexus LS600HL", text: "Lexus LS600HL" },
            { value: "Lexus LX450", text: "Lexus LX450" },
            { value: "Lexus LX470", text: "Lexus LX470" },
            { value: "Lexus LX570", text: "Lexus LX570" },
            { value: "Lexus LX600", text: "Lexus LX600" },
            { value: "Lexus NX200t", text: "Lexus NX200t" },
            { value: "Lexus NX250", text: "Lexus NX250" },
            { value: "Lexus NX300", text: "Lexus NX300" },
            { value: "Lexus NX300h", text: "Lexus NX300h" },
            { value: "Lexus NX350", text: "Lexus NX350" },
            { value: "Lexus NX350H", text: "Lexus NX350H" },
            { value: "Lexus NX450h+", text: "Lexus NX450h+" },
            { value: "Lexus RC 200t", text: "Lexus RC 200t" },
            { value: "Lexus RC 300", text: "Lexus RC 300" },
            { value: "Lexus RC 350", text: "Lexus RC 350" },
            { value: "Lexus RC F", text: "Lexus RC F" },
            { value: "Lexus RX300", text: "Lexus RX300" },
            { value: "Lexus RX330", text: "Lexus RX330" },
            { value: "Lexus RX350", text: "Lexus RX350" },
            { value: "Lexus RX350h", text: "Lexus RX350h" },
            { value: "Lexus RX350L", text: "Lexus RX350L" },
            { value: "Lexus RX400h", text: "Lexus RX400h" },
            { value: "Lexus RX450 Hybrid", text: "Lexus RX450 Hybrid" },
            { value: "Lexus RX450 Hybrid L", text: "Lexus RX450 Hybrid L" },
            { value: "Lexus RX500h", text: "Lexus RX500h" },
            { value: "Lexus RZ450e", text: "Lexus RZ450e" },
            { value: "Lexus SC (excl 430)", text: "Lexus SC (excl 430)" },
            { value: "Lexus SC430", text: "Lexus SC430" },
            { value: "Lexus TX350", text: "Lexus TX350" },
            { value: "Lexus TX500h", text: "Lexus TX500h" },
            { value: "Lexus TX550h", text: "Lexus TX550h" },
            { value: "Lexus UX 200", text: "Lexus UX 200" },
            { value: "Lexus UX 250h", text: "Lexus UX 250h" },
      ],
      Lincoln: [
            { value: "Lincoln Aviator", text: "Lincoln Aviator" },
            { value: "Lincoln Blackwood", text: "Lincoln Blackwood" },
            { value: "Lincoln Continental", text: "Lincoln Continental" },
            { value: "Lincoln Corsair", text: "Lincoln Corsair" },
            { value: "Lincoln LS", text: "Lincoln LS" },
            { value: "Lincoln Mark LT", text: "Lincoln Mark LT" },
            { value: "Lincoln Mark Series", text: "Lincoln Mark Series" },
            { value: "Lincoln MKC", text: "Lincoln MKC" },
            { value: "Lincoln MKS", text: "Lincoln MKS" },
            { value: "Lincoln MKT", text: "Lincoln MKT" },
            { value: "Lincoln MKX", text: "Lincoln MKX" },
            { value: "Lincoln MKZ", text: "Lincoln MKZ" },
            { value: "Lincoln Nautilus", text: "Lincoln Nautilus" },
            { value: "Lincoln Navigator", text: "Lincoln Navigator" },
            { value: "Lincoln Versailles", text: "Lincoln Versailles" },
            { value: "Lincoln Zephyr", text: "Lincoln Zephyr" },
            { value: "Lincoln Other (includes Town Car)", text: "Lincoln Other (includes Town Car)" },
      ],
      Mazda: [
            { value: "Mazda 2", text: "Mazda 2" },
            { value: "Mazda 3", text: "Mazda 3" },
            { value: "Mazda 5", text: "Mazda 5" },
            { value: "Mazda 6", text: "Mazda 6" },
            { value: "Mazda 323", text: "Mazda 323" },
            { value: "Mazda 626", text: "Mazda 626" },
            { value: "Mazda 808", text: "Mazda 808" },
            { value: "Mazda 929", text: "Mazda 929" },
            { value: "Mazda 1200", text: "Mazda 1200" },
            { value: "Mazda 1800", text: "Mazda 1800" },
            { value: "Mazda Cosmo", text: "Mazda Cosmo" },
            { value: "Mazda CX3", text: "Mazda CX3" },
            { value: "Mazda CX5", text: "Mazda CX5" },
            { value: "Mazda CX7", text: "Mazda CX7" },
            { value: "Mazda CX9", text: "Mazda CX9" },
            { value: "Mazda CX30", text: "Mazda CX30" },
            { value: "Mazda CX50", text: "Mazda CX50" },
            { value: "Mazda CX70", text: "Mazda CX70" },
            { value: "Mazda CX90", text: "Mazda CX90" },
            { value: "Mazda GLC", text: "Mazda GLC" },
            { value: "Mazda MPV Van", text: "Mazda MPV Van" },
            { value: "Mazda MX3", text: "Mazda MX3" },
            { value: "Mazda MX6", text: "Mazda MX6" },
            { value: "Mazda MX30", text: "Mazda MX30" },
            { value: "Mazda Miata MX5", text: "Mazda Miata MX5" },
            { value: "Mazda Millenia", text: "Mazda Millenia" },
            { value: "Mazda Navajo", text: "Mazda Navajo" },
            { value: "Mazda Pickup-B1600", text: "Mazda Pickup-B1600" },
            { value: "Mazda Pickup-B1800", text: "Mazda Pickup-B1800" },
            { value: "Mazda Pickup-B2000", text: "Mazda Pickup-B2000" },
            { value: "Mazda Pickup-B2200", text: "Mazda Pickup-B2200" },
            { value: "Mazda Pickup-B2300", text: "Mazda Pickup-B2300" },
            { value: "Mazda Pickup-B2500", text: "Mazda Pickup-B2500" },
            { value: "Mazda Pickup-B2600", text: "Mazda Pickup-B2600" },
            { value: "Mazda Pickup-B3000", text: "Mazda Pickup-B3000" },
            { value: "Mazda Pickup-B4000", text: "Mazda Pickup-B4000" },
            { value: "Mazda Pickup-Rotary", text: "Mazda Pickup-Rotary" },
            { value: "Mazda Protege", text: "Mazda Protege" },
            { value: "Mazda RX2", text: "Mazda RX2" },
            { value: "Mazda RX3", text: "Mazda RX3" },
            { value: "Mazda RX4", text: "Mazda RX4" },
            { value: "Mazda RX7", text: "Mazda RX7" },
            { value: "Mazda RX8", text: "Mazda RX8" },
            { value: "Mazda Tribute", text: "Mazda Tribute" },
      ],
      Mercedes: [
            { value: "Mercedes 170", text: "Mercedes 170" },
            { value: "Mercedes 190", text: "Mercedes 190" },
            { value: "Mercedes 200", text: "Mercedes 200" },
            { value: "Mercedes 218", text: "Mercedes 218" },
            { value: "Mercedes 219", text: "Mercedes 219" },
            { value: "Mercedes 220", text: "Mercedes 220" },
            { value: "Mercedes 230-4 Cyl", text: "Mercedes 230-4 Cyl" },
            { value: "Mercedes 230-6 Cyl", text: "Mercedes 230-6 Cyl" },
            { value: "Mercedes 240D", text: "Mercedes 240D" },
            { value: "Mercedes 250", text: "Mercedes 250" },
            { value: "Mercedes 260E", text: "Mercedes 260E" },
            { value: "Mercedes 280", text: "Mercedes 280" },
            { value: "Mercedes 300D (includes CD/D/SD/TD)", text: "Mercedes 300D (includes CD/D/SD/TD)" },
            { value: "Mercedes 300E", text: "Mercedes 300E" },
            { value: "Mercedes 300SL", text: "Mercedes 300SL" },
            { value: "Mercedes 320", text: "Mercedes 320" },
            { value: "Mercedes 350", text: "Mercedes 350" },
            { value: "Mercedes 380", text: "Mercedes 380" },
            { value: "Mercedes 400", text: "Mercedes 400" },
            { value: "Mercedes 420", text: "Mercedes 420" },
            { value: "Mercedes 450", text: "Mercedes 450" },
            { value: "Mercedes 500", text: "Mercedes 500" },
            { value: "Mercedes 560", text: "Mercedes 560" },
            { value: "Mercedes 600", text: "Mercedes 600" },
            { value: "Mercedes AMG GT", text: "Mercedes AMG GT" },
            { value: "Mercedes A Class", text: "Mercedes A Class" },
            { value: "Mercedes B Class", text: "Mercedes B Class" },
            { value: "Mercedes C Class", text: "Mercedes C Class" },
            { value: "Mercedes CL Class", text: "Mercedes CL Class" },
            { value: "Mercedes CLA Class", text: "Mercedes CLA Class" },
            { value: "Mercedes CLK", text: "Mercedes CLK" },
            { value: "Mercedes CLS", text: "Mercedes CLS" },
            { value: "Mercedes E Class", text: "Mercedes E Class" },
            { value: "Mercedes EQB Class", text: "Mercedes EQB Class" },
            { value: "Mercedes EQE Class", text: "Mercedes EQE Class" },
            { value: "Mercedes EQE Class SUV", text: "Mercedes EQE Class SUV" },
            { value: "Mercedes EQS Class", text: "Mercedes EQS Class" },
            { value: "Mercedes EQS Class SUV", text: "Mercedes EQS Class SUV" },
            { value: "Mercedes eSprinter 2500", text: "Mercedes eSprinter 2500" },
            { value: "Mercedes G Class", text: "Mercedes G Class" },
            { value: "Mercedes GL Class", text: "Mercedes GL Class" },
            { value: "Mercedes GLA Class", text: "Mercedes GLA Class" },
            { value: "Mercedes GLB Class", text: "Mercedes GLB Class" },
            { value: "Mercedes GLC Class", text: "Mercedes GLC Class" },
            { value: "Mercedes GLE Class", text: "Mercedes GLE Class" },
            { value: "Mercedes GLK Class", text: "Mercedes GLK Class" },
            { value: "Mercedes GLS Class", text: "Mercedes GLS Class" },
            { value: "Mercedes ML Series", text: "Mercedes ML Series" },
            { value: "Mercedes Metris", text: "Mercedes Metris" },
            { value: "Mercedes R Class", text: "Mercedes R Class" },
            { value: "Mercedes S Class", text: "Mercedes S Class" },
            { value: "Mercedes SL Class", text: "Mercedes SL Class" },
            { value: "Mercedes SLC Class", text: "Mercedes SLC Class" },
            { value: "Mercedes SLK", text: "Mercedes SLK" },
            { value: "Mercedes SLR", text: "Mercedes SLR" },
            { value: "Mercedes SLS", text: "Mercedes SLS" },
            { value: "Mercedes Sprinter 1500", text: "Mercedes Sprinter 1500" },
            { value: "Mercedes Sprinter 2500", text: "Mercedes Sprinter 2500" },
            { value: "Mercedes Sprinter 3500", text: "Mercedes Sprinter 3500" },
            { value: "Mercedes Sprinter 4500", text: "Mercedes Sprinter 4500" },
            { value: "Mercedes Truck", text: "Mercedes Truck" },
      ],
      Mercury: [
            { value: "Mercury Bobcat", text: "Mercury Bobcat" },
            { value: "Mercury Capri", text: "Mercury Capri" },
            { value: "Mercury Comet", text: "Mercury Comet" },
            { value: "Mercury Cougar", text: "Mercury Cougar" },
            { value: "Mercury Grand Marquis (1979 Down)", text: "Mercury Grand Marquis (1979 Down)" },
            { value: "Mercury Grand Marquis (1980 Up)", text: "Mercury Grand Marquis (1980 Up)" },
            { value: "Mercury LN7", text: "Mercury LN7" },
            { value: "Mercury Lynx (except LN7)", text: "Mercury Lynx (except LN7)" },
            { value: "Mercury Marauder", text: "Mercury Marauder" },
            { value: "Mercury Mariner", text: "Mercury Mariner" },
            { value: "Mercury Marquis (not Grand)", text: "Mercury Marquis (not Grand)" },
            { value: "Mercury Merkur (includes XR4TI and Scorpio)", text: "Mercury Merkur (includes XR4TI and Scorpio)" },
            { value: "Mercury Milan", text: "Mercury Milan" },
            { value: "Mercury Monarch", text: "Mercury Monarch" },
            { value: "Mercury Montego", text: "Mercury Montego" },
            { value: "Mercury Monterey", text: "Mercury Monterey" },
            { value: "Mercury Mountaineer", text: "Mercury Mountaineer" },
            { value: "Mercury Mystique", text: "Mercury Mystique" },
            { value: "Mercury Sable", text: "Mercury Sable" },
            { value: "Mercury Topaz", text: "Mercury Topaz" },
            { value: "Mercury Tracer", text: "Mercury Tracer" },
            { value: "Mercury Villager", text: "Mercury Villager" },
            { value: "Mercury Zephyr", text: "Mercury Zephyr" },
            { value: "Mercury Other", text: "Mercury Other" },
      ],
      Mini: [
            { value: "Mini (Austin)", text: "Mini (Austin)" },
            { value: "Mini Cooper", text: "Mini Cooper" },
            { value: "Mini Cooper Clubman", text: "Mini Cooper Clubman" },
            { value: "Mini Cooper Countryman", text: "Mini Cooper Countryman" },
            { value: "Mini Cooper Paceman", text: "Mini Cooper Paceman" },
      ],
      Mitsubishi: [
            { value: "Mitsubishi 3000", text: "Mitsubishi 3000" },
            { value: "Mitsubishi Cordia", text: "Mitsubishi Cordia" },
            { value: "Mitsubishi Diamante", text: "Mitsubishi Diamante" },
            { value: "Mitsubishi Eclipse", text: "Mitsubishi Eclipse" },
            { value: "Mitsubishi Eclipse Cross", text: "Mitsubishi Eclipse Cross" },
            { value: "Mitsubishi Endeavor", text: "Mitsubishi Endeavor" },
            { value: "Mitsubishi Expo", text: "Mitsubishi Expo" },
            { value: "Mitsubishi Fuso", text: "Mitsubishi Fuso" },
            { value: "Mitsubishi Galant", text: "Mitsubishi Galant" },
            { value: "Mitsubishi i MiEV", text: "Mitsubishi i MiEV" },
            { value: "Mitsubishi Lancer", text: "Mitsubishi Lancer" },
            { value: "Mitsubishi Minicab", text: "Mitsubishi Minicab" },
            { value: "Mitsubishi Mirage", text: "Mitsubishi Mirage" },
            { value: "Mitsubishi Montero", text: "Mitsubishi Montero" },
            { value: "Mitsubishi Montero-Sport", text: "Mitsubishi Montero-Sport" },
            { value: "Mitsubishi Outlander", text: "Mitsubishi Outlander" },
            { value: "Mitsubishi Outlander Sport", text: "Mitsubishi Outlander Sport" },
            { value: "Mitsubishi Pickup (See also Dodge D50)", text: "Mitsubishi Pickup (See also Dodge D50)" },
            { value: "Mitsubishi Precis", text: "Mitsubishi Precis" },
            { value: "Mitsubishi Raider", text: "Mitsubishi Raider" },
            { value: "Mitsubishi RVR", text: "Mitsubishi RVR" },
            { value: "Mitsubishi Sigma", text: "Mitsubishi Sigma" },
            { value: "Mitsubishi Space Wagon", text: "Mitsubishi Space Wagon" },
            { value: "Mitsubishi Starion", text: "Mitsubishi Starion" },
            { value: "Mitsubishi Tredia", text: "Mitsubishi Tredia" },
            { value: "Mitsubishi Van", text: "Mitsubishi Van" },
      ],
      Nissan: [
            { value: "Nissan 1200", text: "Nissan 1200" },
            { value: "Nissan 1600", text: "Nissan 1600" },
            { value: "Nissan 200SX", text: "Nissan 200SX" },
            { value: "Nissan 210", text: "Nissan 210" },
            { value: "Nissan 240SX", text: "Nissan 240SX" },
            { value: "Nissan 240Z", text: "Nissan 240Z" },
            { value: "Nissan 260Z", text: "Nissan 260Z" },
            { value: "Nissan 280-Z", text: "Nissan 280-Z" },
            { value: "Nissan 280-ZX", text: "Nissan 280-ZX" },
            { value: "Nissan 300ZX", text: "Nissan 300ZX" },
            { value: "Nissan 350Z", text: "Nissan 350Z" },
            { value: "Nissan 370Z", text: "Nissan 370Z" },
            { value: "Nissan 310", text: "Nissan 310" },
            { value: "Nissan 311", text: "Nissan 311" },
            { value: "Nissan 410", text: "Nissan 410" },
            { value: "Nissan 411", text: "Nissan 411" },
            { value: "Nissan 510", text: "Nissan 510" },
            { value: "Nissan 610", text: "Nissan 610" },
            { value: "Nissan 710", text: "Nissan 710" },
            { value: "Nissan 810", text: "Nissan 810" },
            { value: "Nissan Almera", text: "Nissan Almera" },
            { value: "Nissan Altima", text: "Nissan Altima" },
            { value: "Nissan Ariya", text: "Nissan Ariya" },
            { value: "Nissan Armada", text: "Nissan Armada" },
            { value: "Nissan Axxess", text: "Nissan Axxess" },
            { value: "Nissan B210", text: "Nissan B210" },
            { value: "Nissan Cube", text: "Nissan Cube" },
            { value: "Nissan F10", text: "Nissan F10" },
            { value: "Nissan Frontier", text: "Nissan Frontier" },
            { value: "Nissan GTR", text: "Nissan GTR" },
            { value: "Nissan Juke", text: "Nissan Juke" },
            { value: "Nissan Kicks", text: "Nissan Kicks" },
            { value: "Nissan Leaf", text: "Nissan Leaf" },
            { value: "Nissan Lucino", text: "Nissan Lucino" },
            { value: "Nissan Maxima (1981 Down)", text: "Nissan Maxima (1981 Down)" },
            { value: "Nissan Maxima (1982 Up)", text: "Nissan Maxima (1982 Up)" },
            { value: "Nissan Micra", text: "Nissan Micra" },
            { value: "Nissan Murano", text: "Nissan Murano" },
            { value: "Nissan NV 200", text: "Nissan NV 200" },
            { value: "Nissan NV 1500", text: "Nissan NV 1500" },
            { value: "Nissan NV 2500", text: "Nissan NV 2500" },
            { value: "Nissan NV 3500", text: "Nissan NV 3500" },
            { value: "Nissan NX", text: "Nissan NX" },
            { value: "Nissan Pathfinder", text: "Nissan Pathfinder" },
            { value: "Nissan Patrol", text: "Nissan Patrol" },
            { value: "Nissan Platina", text: "Nissan Platina" },
            { value: "Nissan Pulsar", text: "Nissan Pulsar" },
            { value: "Nissan Qashqai", text: "Nissan Qashqai" },
            { value: "Nissan Quest", text: "Nissan Quest" },
            { value: "Nissan Rogue", text: "Nissan Rogue" },
            { value: "Nissan Rogue Sport", text: "Nissan Rogue Sport" },
            { value: "Nissan Sentra", text: "Nissan Sentra" },
            { value: "Nissan Stanza (Excl Van)", text: "Nissan Stanza (Excl Van)" },
            { value: "Nissan Stanza Van", text: "Nissan Stanza Van" },
            { value: "Nissan Tida", text: "Nissan Tida" },
            { value: "Nissan Truck", text: "Nissan Truck" },
            { value: "Nissan Truck-Titan", text: "Nissan Truck-Titan" },
            { value: "Nissan Truck-Titan XD", text: "Nissan Truck-Titan XD" },
            { value: "Nissan Tsubame", text: "Nissan Tsubame" },
            { value: "Nissan UD Series", text: "Nissan UD Series" },
            { value: "Nissan Van GC22", text: "Nissan Van GC22" },
            { value: "Nissan Versa", text: "Nissan Versa" },
            { value: "Nissan X Trail", text: "Nissan X Trail" },
            { value: "Nissan Xterra", text: "Nissan Xterra" },
            { value: "Nissan Z", text: "Nissan Z" },
      ],
      Oldsmobile: [
            { value: "Oldsmobile 88 (1979 Down)", text: "Oldsmobile 88 (1979 Down)" },
            { value: "Oldsmobile 88 (1980 Up)", text: "Oldsmobile 88 (1980 Up)" },
            { value: "Oldsmobile 98 (1979 Down)", text: "Oldsmobile 98 (1979 Down)" },
            { value: "Oldsmobile 98 (1980 Up)", text: "Oldsmobile 98 (1980 Up)" },
            { value: "Oldsmobile Achieva", text: "Oldsmobile Achieva" },
            { value: "Oldsmobile Alero", text: "Oldsmobile Alero" },
            { value: "Oldsmobile Aurora", text: "Oldsmobile Aurora" },
            { value: "Oldsmobile Bravada", text: "Oldsmobile Bravada" },
            { value: "Oldsmobile Calais (1984 Down)", text: "Oldsmobile Calais (1984 Down)" },
            { value: "Oldsmobile Calais (1985 Up)", text: "Oldsmobile Calais (1985 Up)" },
            { value: "Oldsmobile Ciera", text: "Oldsmobile Ciera" },
            { value: "Oldsmobile Custom Cruiser (1979 Down)", text: "Oldsmobile Custom Cruiser (1979 Down)" },
            { value: "Oldsmobile Custom Cruiser (1980 Up)", text: "Oldsmobile Custom Cruiser (1980 Up)" },
            { value: "Oldsmobile Cutlass (1972 Down)", text: "Oldsmobile Cutlass (1972 Down)" },
            { value: "Oldsmobile Cutlass (1973 Up)", text: "Oldsmobile Cutlass (1973 Up)" },
            { value: "Oldsmobile F85", text: "Oldsmobile F85" },
            { value: "Oldsmobile Firenza", text: "Oldsmobile Firenza" },
            { value: "Oldsmobile Intrigue", text: "Oldsmobile Intrigue" },
            { value: "Oldsmobile Omega", text: "Oldsmobile Omega" },
            { value: "Oldsmobile Silhouette", text: "Oldsmobile Silhouette" },
            { value: "Oldsmobile Starfire", text: "Oldsmobile Starfire" },
            { value: "Oldsmobile Supreme-Calais (1988 Up)", text: "Oldsmobile Supreme-Calais (1988 Up)" },
            { value: "Oldsmobile Supreme-Cutlass (1988 Up)", text: "Oldsmobile Supreme-Cutlass (1988 Up)" },
            { value: "Oldsmobile Supreme (1972 Down)", text: "Oldsmobile Supreme (1972 Down)" },
            { value: "Oldsmobile Supreme (1973-1987)", text: "Oldsmobile Supreme (1973-1987)" },
            { value: "Oldsmobile Toronado", text: "Oldsmobile Toronado" },
            { value: "Oldsmobile Other", text: "Oldsmobile Other" },
      ],
      Opel: [
            { value: "Opel", text: "Opel" },
      ],
      Peugeot: [
            { value: "Peugeot 304", text: "Peugeot 304" },
            { value: "Peugeot 403", text: "Peugeot 403" },
            { value: "Peugeot 404", text: "Peugeot 404" },
            { value: "Peugeot 405", text: "Peugeot 405" },
            { value: "Peugeot 504", text: "Peugeot 504" },
            { value: "Peugeot 505", text: "Peugeot 505" },
            { value: "Peugeot 604", text: "Peugeot 604" },
      ],
      Plymouth: [
            { value: "Plymouth Acclaim", text: "Plymouth Acclaim" },
            { value: "Plymouth Arrow-Car", text: "Plymouth Arrow-Car" },
            { value: "Plymouth Arrow-Truck (See also Dodge D50)", text: "Plymouth Arrow-Truck (See also Dodge D50)" },
            { value: "Plymouth Barracuda", text: "Plymouth Barracuda" },
            { value: "Plymouth Breeze", text: "Plymouth Breeze" },
            { value: "Plymouth Caravelle", text: "Plymouth Caravelle" },
            { value: "Plymouth Champ", text: "Plymouth Champ" },
            { value: "Plymouth Cricket", text: "Plymouth Cricket" },
            { value: "Plymouth Duster (1970-1976)", text: "Plymouth Duster (1970-1976)" },
            { value: "Plymouth Duster (1979-1980)", text: "Plymouth Duster (1979-1980)" },
            { value: "Plymouth Duster (1985-1987)", text: "Plymouth Duster (1985-1987)" },
            { value: "Plymouth Duster (1992-1994)", text: "Plymouth Duster (1992-1994)" },
            { value: "Plymouth Grand Fury (1979 Down)", text: "Plymouth Grand Fury (1979 Down)" },
            { value: "Plymouth Grand Fury (1980 Up)", text: "Plymouth Grand Fury (1980 Up)" },
            { value: "Plymouth Horizon", text: "Plymouth Horizon" },
            { value: "Plymouth Laser", text: "Plymouth Laser" },
            { value: "Plymouth Neon", text: "Plymouth Neon" },
            { value: "Plymouth Prowler", text: "Plymouth Prowler" },
            { value: "Plymouth Reliant", text: "Plymouth Reliant" },
            { value: "Plymouth Sapporo", text: "Plymouth Sapporo" },
            { value: "Plymouth Scamp (1983 only)", text: "Plymouth Scamp (1983 only)" },
            { value: "Plymouth Scamp (except 1983)", text: "Plymouth Scamp (except 1983)" },
            { value: "Plymouth Sundance", text: "Plymouth Sundance" },
            { value: "Plymouth Trailduster", text: "Plymouth Trailduster" },
            { value: "Plymouth Valiant", text: "Plymouth Valiant" },
            { value: "Plymouth Van 100", text: "Plymouth Van 100" },
            { value: "Plymouth Van 150", text: "Plymouth Van 150" },
            { value: "Plymouth Van 200", text: "Plymouth Van 200" },
            { value: "Plymouth Van 250", text: "Plymouth Van 250" },
            { value: "Plymouth Van 300", text: "Plymouth Van 300" },
            { value: "Plymouth Van 350", text: "Plymouth Van 350" },
            { value: "Plymouth Volare", text: "Plymouth Volare" },
            { value: "Plymouth Voyager", text: "Plymouth Voyager" },
            { value: "Plymouth Other", text: "Plymouth Other" },
      ],
      Pontiac: [
            { value: "Pontiac 1000", text: "Pontiac 1000" },
            { value: "Pontiac 2000-P/J/Sunbird", text: "Pontiac 2000-P/J/Sunbird" },
            { value: "Pontiac 6000", text: "Pontiac 6000" },
            { value: "Pontiac Acadian", text: "Pontiac Acadian" },
            { value: "Pontiac Astre", text: "Pontiac Astre" },
            { value: "Pontiac Aztek", text: "Pontiac Aztek" },
            { value: "Pontiac Bonneville (1979 Down)", text: "Pontiac Bonneville (1979 Down)" },
            { value: "Pontiac Bonneville (1980 Up)", text: "Pontiac Bonneville (1980 Up)" },
            { value: "Pontiac Catalina (1979 Down)", text: "Pontiac Catalina (1979 Down)" },
            { value: "Pontiac Catalina (1980 Up)", text: "Pontiac Catalina (1980 Up)" },
            { value: "Pontiac Fiero", text: "Pontiac Fiero" },
            { value: "Pontiac Firebird", text: "Pontiac Firebird" },
            { value: "Pontiac Firefly", text: "Pontiac Firefly" },
            { value: "Pontiac G3", text: "Pontiac G3" },
            { value: "Pontiac G4", text: "Pontiac G4" },
            { value: "Pontiac G5", text: "Pontiac G5" },
            { value: "Pontiac G6", text: "Pontiac G6" },
            { value: "Pontiac G8", text: "Pontiac G8" },
            { value: "Pontiac Grand AM", text: "Pontiac Grand AM" },
            { value: "Pontiac Grand Prix", text: "Pontiac Grand Prix" },
            { value: "Pontiac GTO (New Style)", text: "Pontiac GTO (New Style)" },
            { value: "Pontiac GTO (Old Style)", text: "Pontiac GTO (Old Style)" },
            { value: "Pontiac Lemans", text: "Pontiac Lemans" },
            { value: "Pontiac Matiz", text: "Pontiac Matiz" },
            { value: "Pontiac Montana", text: "Pontiac Montana" },
            { value: "Pontiac Parisienne (1979 Down)", text: "Pontiac Parisienne (1979 Down)" },
            { value: "Pontiac Parisienne (1980 Up)", text: "Pontiac Parisienne (1980 Up)" },
            { value: "Pontiac Phoenix", text: "Pontiac Phoenix" },
            { value: "Pontiac Pursuit", text: "Pontiac Pursuit" },
            { value: "Pontiac Solstice", text: "Pontiac Solstice" },
            { value: "Pontiac Sunbird", text: "Pontiac Sunbird" },
            { value: "Pontiac Sunburst", text: "Pontiac Sunburst" },
            { value: "Pontiac Sunfire", text: "Pontiac Sunfire" },
            { value: "Pontiac Sunrunner", text: "Pontiac Sunrunner" },
            { value: "Pontiac Tempest", text: "Pontiac Tempest" },
            { value: "Pontiac Torrent", text: "Pontiac Torrent" },
            { value: "Pontiac Trans Sport", text: "Pontiac Trans Sport" },
            { value: "Pontiac Van-Montana", text: "Pontiac Van-Montana" },
            { value: "Pontiac Ventura", text: "Pontiac Ventura" },
            { value: "Pontiac Vibe", text: "Pontiac Vibe" },
            { value: "Pontiac Wave", text: "Pontiac Wave" },
            { value: "Pontiac Other", text: "Pontiac Other" },
      ],
      Porsche: [
            { value: "Porsche 356", text: "Porsche 356" },
            { value: "Porsche 911/930", text: "Porsche 911/930" },
            { value: "Porsche 912/e", text: "Porsche 912/e" },
            { value: "Porsche 914", text: "Porsche 914" },
            { value: "Porsche 918", text: "Porsche 918" },
            { value: "Porsche 924", text: "Porsche 924" },
            { value: "Porsche 928", text: "Porsche 928" },
            { value: "Porsche 944", text: "Porsche 944" },
            { value: "Porsche 968", text: "Porsche 968" },
            { value: "Porsche Boxster", text: "Porsche Boxster" },
            { value: "Porsche Carrera-GT", text: "Porsche Carrera-GT" },
            { value: "Porsche Cayenne", text: "Porsche Cayenne" },
            { value: "Porsche Cayman S", text: "Porsche Cayman S" },
            { value: "Porsche Macan", text: "Porsche Macan" },
            { value: "Porsche Panamera", text: "Porsche Panamera" },
            { value: "Porsche Taycan", text: "Porsche Taycan" },
      ],
      Renault: [
            { value: "Renault 18I", text: "Renault 18I" },
            { value: "Renault Alliance", text: "Renault Alliance" },
            { value: "Renault Clio", text: "Renault Clio" },
            { value: "Renault Dauphine", text: "Renault Dauphine" },
            { value: "Renault Encore", text: "Renault Encore" },
            { value: "Renault Fuego", text: "Renault Fuego" },
            { value: "Renault Gordini", text: "Renault Gordini" },
            { value: "Renault Lecar/R5", text: "Renault Lecar/R5" },
            { value: "Renault Medallion", text: "Renault Medallion" },
            { value: "Renault Megane", text: "Renault Megane" },
            { value: "Renault R8", text: "Renault R8" },
            { value: "Renault R10", text: "Renault R10" },
            { value: "Renault R12", text: "Renault R12" },
            { value: "Renault R15", text: "Renault R15" },
            { value: "Renault R16", text: "Renault R16" },
            { value: "Renault R17", text: "Renault R17" },
            { value: "Renault R30", text: "Renault R30" },
            { value: "Renault Other", text: "Renault Other" },
      ],
      Saab: [
            { value: "Saab 9-3 (1999 Up)", text: "Saab 9-3 (1999 Up)" },
            { value: "Saab 9-5 (1999 Up)", text: "Saab 9-5 (1999 Up)" },
            { value: "Saab 92x", text: "Saab 92x" },
            { value: "Saab 93 (1960 Down)", text: "Saab 93 (1960 Down)" },
            { value: "Saab 94x", text: "Saab 94x" },
            { value: "Saab 95 (1972 Down)", text: "Saab 95 (1972 Down)" },
            { value: "Saab 96", text: "Saab 96" },
            { value: "Saab 97x", text: "Saab 97x" },
            { value: "Saab 99", text: "Saab 99" },
            { value: "Saab 900 (incl Turbo)", text: "Saab 900 (incl Turbo)" },
            { value: "Saab 9000 (incl Turbo)", text: "Saab 9000 (incl Turbo)" },
            { value: "Saab Monte Carlo", text: "Saab Monte Carlo" },
            { value: "Saab Sonett", text: "Saab Sonett" },
            { value: "Saab Sonett III", text: "Saab Sonett III" },
      ],
      Saturn: [
            { value: "Saturn Astra", text: "Saturn Astra" },
            { value: "Saturn Aura", text: "Saturn Aura" },
            { value: "Saturn EV1", text: "Saturn EV1" },
            { value: "Saturn Ion", text: "Saturn Ion" },
            { value: "Saturn L Series", text: "Saturn L Series" },
            { value: "Saturn S Series", text: "Saturn S Series" },
            { value: "Saturn Outlook", text: "Saturn Outlook" },
            { value: "Saturn Relay", text: "Saturn Relay" },
            { value: "Saturn Sky", text: "Saturn Sky" },
            { value: "Saturn Vue", text: "Saturn Vue" },
      ],
      Scion: [
            { value: "Scion FRS", text: "Scion FRS" },
            { value: "Scion iA", text: "Scion iA" },
            { value: "Scion iM", text: "Scion iM" },
            { value: "Scion iQ", text: "Scion iQ" },
            { value: "Scion tC", text: "Scion tC" },
            { value: "Scion xA", text: "Scion xA" },
            { value: "Scion xB", text: "Scion xB" },
            { value: "Scion xD", text: "Scion xD" },
      ],
      Subaru: [
            { value: "Subaru Ascent", text: "Subaru Ascent" },
            { value: "Subaru Baja", text: "Subaru Baja" },
            { value: "Subaru Brat", text: "Subaru Brat" },
            { value: "Subaru BRZ", text: "Subaru BRZ" },
            { value: "Subaru Chaser", text: "Subaru Chaser" },
            { value: "Subaru Crosstrek", text: "Subaru Crosstrek" },
            { value: "Subaru Forester", text: "Subaru Forester" },
            { value: "Subaru Impreza", text: "Subaru Impreza" },
            { value: "Subaru Justy", text: "Subaru Justy" },
            { value: "Subaru Legacy", text: "Subaru Legacy" },
            { value: "Subaru Loyale", text: "Subaru Loyale" },
            { value: "Subaru Outback (Impreza)", text: "Subaru Outback (Impreza)" },
            { value: "Subaru Outback (Legacy)", text: "Subaru Outback (Legacy)" },
            { value: "Subaru Sambar", text: "Subaru Sambar" },
            { value: "Subaru Solterra", text: "Subaru Solterra" },
            { value: "Subaru Streega", text: "Subaru Streega" },
            { value: "Subaru SVX", text: "Subaru SVX" },
            { value: "Subaru Tribeca", text: "Subaru Tribeca" },
            { value: "Subaru WRX (2014 Down)", text: "Subaru WRX (2014 Down)" },
            { value: "Subaru WRX (2015 Up)", text: "Subaru WRX (2015 Up)" },
            { value: "Subaru XT", text: "Subaru XT" },
            { value: "Subaru XV Crosstrek", text: "Subaru XV Crosstrek" },
            { value: "Subaru Other", text: "Subaru Other" },
      ],
      Suzuki: [
            { value: "Suzuki Aerio", text: "Suzuki Aerio" },
            { value: "Suzuki Carry", text: "Suzuki Carry" },
            { value: "Suzuki Esteem", text: "Suzuki Esteem" },
            { value: "Suzuki Equator", text: "Suzuki Equator" },
            { value: "Suzuki Forenza", text: "Suzuki Forenza" },
            { value: "Suzuki Forsa", text: "Suzuki Forsa" },
            { value: "Suzuki Kizashi", text: "Suzuki Kizashi" },
            { value: "Suzuki Reno", text: "Suzuki Reno" },
            { value: "Suzuki Samurai", text: "Suzuki Samurai" },
            { value: "Suzuki Sidekick", text: "Suzuki Sidekick" },
            { value: "Suzuki SJ410", text: "Suzuki SJ410" },
            { value: "Suzuki Swift", text: "Suzuki Swift" },
            { value: "Suzuki SX4", text: "Suzuki SX4" },
            { value: "Suzuki Verona", text: "Suzuki Verona" },
            { value: "Suzuki Vitara", text: "Suzuki Vitara" },
            { value: "Suzuki X90", text: "Suzuki X90" },
            { value: "Suzuki XL7", text: "Suzuki XL7" },
      ],
      Toyota: [
            { value: "Toyota 86", text: "Toyota 86" },
            { value: "Toyota 4Runner", text: "Toyota 4Runner" },
            { value: "Toyota Aristo", text: "Toyota Aristo" },
            { value: "Toyota Avalon", text: "Toyota Avalon" },
            { value: "Toyota BZ4X", text: "Toyota BZ4X" },
            { value: "Toyota CHR", text: "Toyota CHR" },
            { value: "Toyota Camry", text: "Toyota Camry" },
            { value: "Toyota Carina", text: "Toyota Carina" },
            { value: "Toyota Celica", text: "Toyota Celica" },
            { value: "Toyota Corolla", text: "Toyota Corolla" },
            { value: "Toyota Corolla Cross", text: "Toyota Corolla Cross" },
            { value: "Toyota Corolla FX/FX16", text: "Toyota Corolla FX/FX16" },
            { value: "Toyota Corolla iM", text: "Toyota Corolla iM" },
            { value: "Toyota Corona MKII", text: "Toyota Corona MKII" },
            { value: "Toyota Corona not MKII", text: "Toyota Corona not MKII" },
            { value: "Toyota Cressida", text: "Toyota Cressida" },
            { value: "Toyota Crown", text: "Toyota Crown" },
            { value: "Toyota Echo", text: "Toyota Echo" },
            { value: "Toyota FJ Cruiser", text: "Toyota FJ Cruiser" },
            { value: "Toyota FX/FX16", text: "Toyota FX/FX16" },
            { value: "Toyota GR86", text: "Toyota GR86" },
            { value: "Toyota GR Corolla", text: "Toyota GR Corolla" },
            { value: "Toyota GR Supra", text: "Toyota GR Supra" },
            { value: "Toyota Grand Highlander", text: "Toyota Grand Highlander" },
            { value: "Toyota HiAce", text: "Toyota HiAce" },
            { value: "Toyota Highlander", text: "Toyota Highlander" },
            { value: "Toyota Land Cruiser", text: "Toyota Land Cruiser" },
            { value: "Toyota Matrix", text: "Toyota Matrix" },
            { value: "Toyota Mirai", text: "Toyota Mirai" },
            { value: "Toyota MR2", text: "Toyota MR2" },
            { value: "Toyota Paseo", text: "Toyota Paseo" },
            { value: "Toyota Previa", text: "Toyota Previa" },
            { value: "Toyota Prius", text: "Toyota Prius" },
            { value: "Toyota RAV4", text: "Toyota RAV4" },
            { value: "Toyota Sequoia", text: "Toyota Sequoia" },
            { value: "Toyota Sienna", text: "Toyota Sienna" },
            { value: "Toyota Solara", text: "Toyota Solara" },
            { value: "Toyota Starlet", text: "Toyota Starlet" },
            { value: "Toyota Stout", text: "Toyota Stout" },
            { value: "Toyota Supra", text: "Toyota Supra" },
            { value: "Toyota T100", text: "Toyota T100" },
            { value: "Toyota Tacoma", text: "Toyota Tacoma" },
            { value: "Toyota Tercel", text: "Toyota Tercel" },
            { value: "Toyota Truck (except T100 & Tundra)", text: "Toyota Truck (except T100 & Tundra)" },
            { value: "Toyota Tundra", text: "Toyota Tundra" },
            { value: "Toyota Van (See also Previa)", text: "Toyota Van (See also Previa)" },
            { value: "Toyota Venza", text: "Toyota Venza" },
            { value: "Toyota Yaris", text: "Toyota Yaris" },
            { value: "Toyota Yaris iA", text: "Toyota Yaris iA" },
      ],
      Triumph: [
            { value: "Triumph GT6", text: "Triumph GT6" },
            { value: "Triumph Spitfire", text: "Triumph Spitfire" },
            { value: "Triumph Stag", text: "Triumph Stag" },
            { value: "Triumph TR2", text: "Triumph TR2" },
            { value: "Triumph TR3", text: "Triumph TR3" },
            { value: "Triumph TR4", text: "Triumph TR4" },
            { value: "Triumph TR4A", text: "Triumph TR4A" },
            { value: "Triumph TR6", text: "Triumph TR6" },
            { value: "Triumph TR7", text: "Triumph TR7" },
            { value: "Triumph TR8", text: "Triumph TR8" },
            { value: "Triumph TR250", text: "Triumph TR250" },
      ],
      Volkswagen: [
            { value: "Volkswagen 412/411", text: "Volkswagen 412/411" },
            { value: "Volkswagen Arteon", text: "Volkswagen Arteon" },
            { value: "Volkswagen Atlas", text: "Volkswagen Atlas" },
            { value: "Volkswagen Atlas Cross Sport", text: "Volkswagen Atlas Cross Sport" },
            { value: "Volkswagen Beetle/Bug", text: "Volkswagen Beetle/Bug" },
            { value: "Volkswagen Cabrio", text: "Volkswagen Cabrio" },
            { value: "Volkswagen Cabriolet", text: "Volkswagen Cabriolet" },
            { value: "Volkswagen CC", text: "Volkswagen CC" },
            { value: "Volkswagen Corrado", text: "Volkswagen Corrado" },
            { value: "Volkswagen Dasher", text: "Volkswagen Dasher" },
            { value: "Volkswagen Derby", text: "Volkswagen Derby" },
            { value: "Volkswagen Eos", text: "Volkswagen Eos" },
            { value: "Volkswagen Fox", text: "Volkswagen Fox" },
            { value: "Volkswagen Golf", text: "Volkswagen Golf" },
            { value: "Volkswagen Golf GTI", text: "Volkswagen Golf GTI" },
            { value: "Volkswagen ID.4", text: "Volkswagen ID.4" },
            { value: "Volkswagen Jetta", text: "Volkswagen Jetta" },
            { value: "Volkswagen Jetta GLI", text: "Volkswagen Jetta GLI" },
            { value: "Volkswagen Karmann Ghia", text: "Volkswagen Karmann Ghia" },
            { value: "Volkswagen Passat", text: "Volkswagen Passat" },
            { value: "Volkswagen Phaeton", text: "Volkswagen Phaeton" },
            { value: "Volkswagen Pointer", text: "Volkswagen Pointer" },
            { value: "Volkswagen Pointer Truck", text: "Volkswagen Pointer Truck" },
            { value: "Volkswagen Quantum", text: "Volkswagen Quantum" },
            { value: "Volkswagen Rabbit", text: "Volkswagen Rabbit" },
            { value: "Volkswagen Routan", text: "Volkswagen Routan" },
            { value: "Volkswagen Scirocco", text: "Volkswagen Scirocco" },
            { value: "Volkswagen Sedan", text: "Volkswagen Sedan" },
            { value: "Volkswagen Sharan", text: "Volkswagen Sharan" },
            { value: "Volkswagen Taos", text: "Volkswagen Taos" },
            { value: "Volkswagen Thing", text: "Volkswagen Thing" },
            { value: "Volkswagen Tiguan", text: "Volkswagen Tiguan" },
            { value: "Volkswagen Touareg", text: "Volkswagen Touareg" },
            { value: "Volkswagen Type 3", text: "Volkswagen Type 3" },
            { value: "Volkswagen Van-EuroVan", text: "Volkswagen Van-EuroVan" },
            { value: "Volkswagen Van-Transporter", text: "Volkswagen Van-Transporter" },
            { value: "Volkswagen Van-Vanagon", text: "Volkswagen Van-Vanagon" },
            { value: "Volkswagen Other", text: "Volkswagen Other" },
      ],
      Volvo: [
            { value: "Volvo 30 Series", text: "Volvo 30 Series" },
            { value: "Volvo 40 Series", text: "Volvo 40 Series" },
            { value: "Volvo 50 Series", text: "Volvo 50 Series" },
            { value: "Volvo 60 Series", text: "Volvo 60 Series" },
            { value: "Volvo 70 Series", text: "Volvo 70 Series" },
            { value: "Volvo 80 Series", text: "Volvo 80 Series" },
            { value: "Volvo 90 Series", text: "Volvo 90 Series" },
            { value: "Volvo 120 Series", text: "Volvo 120 Series" },
            { value: "Volvo 140 Series", text: "Volvo 140 Series" },
            { value: "Volvo 160 Series", text: "Volvo 160 Series" },
            { value: "Volvo 240", text: "Volvo 240" },
            { value: "Volvo 260", text: "Volvo 260" },
            { value: "Volvo 444/445", text: "Volvo 444/445" },
            { value: "Volvo 544", text: "Volvo 544" },
            { value: "Volvo 740", text: "Volvo 740" },
            { value: "Volvo 760", text: "Volvo 760" },
            { value: "Volvo 780", text: "Volvo 780" },
            { value: "Volvo 850", text: "Volvo 850" },
            { value: "Volvo 940", text: "Volvo 940" },
            { value: "Volvo 960", text: "Volvo 960" },
            { value: "Volvo 1800", text: "Volvo 1800" },
            { value: "Volvo C40", text: "Volvo C40" },
            { value: "Volvo F7", text: "Volvo F7" },
            { value: "Volvo FE6", text: "Volvo FE6" },
            { value: "Volvo S60 (2013 Down)", text: "Volvo S60 (2013 Down)" },
            { value: "Volvo S60 (2014 Up)", text: "Volvo S60 (2014 Up)" },
            { value: "Volvo S90", text: "Volvo S90" },
            { value: "Volvo Truck", text: "Volvo Truck" },
            { value: "Volvo V60", text: "Volvo V60" },
            { value: "Volvo V70", text: "Volvo V70" },
            { value: "Volvo V90", text: "Volvo V90" },
            { value: "Volvo XC40", text: "Volvo XC40" },
            { value: "Volvo XC60 (2013 Down)", text: "Volvo XC60 (2013 Down)" },
            { value: "Volvo XC60 (2014 Up)", text: "Volvo XC60 (2014 Up)" },
            { value: "Volvo XC70", text: "Volvo XC70" },
            { value: "Volvo XC90", text: "Volvo XC90" },
      ],
      Aston: [
            { value: "Aston Martin", text: "Aston Martin" },
      ],
      Asuna: [
            { value: "Asuna", text: "Asuna" },
      ],
      Austin: [
            { value: "Austin", text: "Austin" },
            { value: "Austin Mini", text: "Austin Mini" },
      ],
      Autocar: [
            { value: "Autocar", text: "Autocar" },
      ],
      Avanti: [
            { value: "Avanti", text: "Avanti" },
      ],
      Bentley: [
            { value: "Bentley", text: "Bentley" },
            { value: "Bentley Arnage", text: "Bentley Arnage" },
            { value: "Bentley Azure", text: "Bentley Azure" },
            { value: "Bentley Bentayga", text: "Bentley Bentayga" },
            { value: "Bentley Brooklands", text: "Bentley Brooklands" },
            { value: "Bentley Continental", text: "Bentley Continental" },
            { value: "Bentley Corniche", text: "Bentley Corniche" },
            { value: "Bentley Eight", text: "Bentley Eight" },
            { value: "Bentley Flying Spur", text: "Bentley Flying Spur" },
            { value: "Bentley Mulsanne", text: "Bentley Mulsanne" },
            { value: "Bentley Turbo R", text: "Bentley Turbo R" },
      ],
      Bricklin: [
            { value: "Bricklin", text: "Bricklin" },
      ],
      Brockway: [
            { value: "Brockway", text: "Brockway" },
      ],
      Checker: [
            { value: "Checker", text: "Checker" },
            { value: "Checker Cab", text: "Checker Cab" },
      ],
      Citroen: [
            { value: "Citroen", text: "Citroen" },
      ],
      Delorean: [
            { value: "Delorean", text: "Delorean" },
      ],
      Desoto: [
            { value: "Desoto", text: "Desoto" },
      ],
      DiamondReo: [
            { value: "Diamond Reo", text: "Diamond Reo" },
      ],
      Edsel: [
            { value: "Edsel", text: "Edsel" },
      ],
      FWDTrucks: [
            { value: "FWD Trucks", text: "FWD Trucks" },
      ],
      Ferrari: [
            { value: "Ferrari", text: "Ferrari" },
      ],
      Fisker: [
            { value: "Fisker Karma", text: "Fisker Karma" },
            { value: "Fisker Ocean", text: "Fisker Ocean" },
      ],
      Freightliner: [
            { value: "Freightliner", text: "Freightliner" },
      ],
      Freuhauf: [
            { value: "Freuhauf", text: "Freuhauf" },
      ],
      Genesis: [
            { value: "Genesis G70", text: "Genesis G70" },
            { value: "Genesis G80", text: "Genesis G80" },
            { value: "Genesis G90", text: "Genesis G90" },
            { value: "Genesis GV60", text: "Genesis GV60" },
            { value: "Genesis GV70", text: "Genesis GV70" },
            { value: "Genesis GV80", text: "Genesis GV80" },
      ],
      HinoTruck: [
            { value: "Hino Truck", text: "Hino Truck" },
      ],
      Hudson: [
            { value: "Hudson", text: "Hudson" },
      ],
      IH: [
            { value: "IH (Pickup & Travelall)", text: "IH (Pickup & Travelall)" },
            { value: "IH Scout & Scout II", text: "IH Scout & Scout II" },
            { value: "IH Truck (Big)", text: "IH Truck (Big)" },
      ],
      Kaiser: [
            { value: "Kaiser", text: "Kaiser" },
      ],
      Kenworth: [
            { value: "Kenworth", text: "Kenworth" },
      ],
      Lada: [
            { value: "Lada", text: "Lada" },
      ],
      Lamborghini: [
            { value: "Lamborghini", text: "Lamborghini" },
      ],
      Lancia: [
            { value: "Lancia", text: "Lancia" },
      ],
      Lotus: [
            { value: "Lotus", text: "Lotus" },
      ],
      Lucid: [
            { value: "Lucid Air", text: "Lucid Air" },
            { value: "Lucid Gravity", text: "Lucid Gravity" },
      ],
      MG: [
            { value: "MG MGB", text: "MG MGB" },
            { value: "MG Midget", text: "MG Midget" },
            { value: "MG Other", text: "MG Other" },
      ],
      Mac: [
            { value: "Mac", text: "Mac" },
      ],
      Marmon: [
            { value: "Marmon Truck", text: "Marmon Truck" },
      ],
      Maserati: [
            { value: "Maserati", text: "Maserati" },
            { value: "Maserati BiTurbo", text: "Maserati BiTurbo" },
            { value: "Maserati Ghibli", text: "Maserati Ghibli" },
            { value: "Maserati GranTurismo", text: "Maserati GranTurismo" },
            { value: "Maserati Grecale", text: "Maserati Grecale" },
            { value: "Maserati Grecale GT", text: "Maserati Grecale GT" },
            { value: "Maserati Levante", text: "Maserati Levante" },
            { value: "Maserati Quattroporte", text: "Maserati Quattroporte" },
      ],
      Maybach: [
            { value: "Maybach", text: "Maybach" },
      ],
      McLaren: [
            { value: "McLaren 540C", text: "McLaren 540C" },
            { value: "McLaren 570GT", text: "McLaren 570GT" },
            { value: "McLaren 570S", text: "McLaren 570S" },
            { value: "McLaren 600LT", text: "McLaren 600LT" },
            { value: "McLaren 620R", text: "McLaren 620R" },
            { value: "McLaren 650S", text: "McLaren 650S" },
            { value: "McLaren 675LT", text: "McLaren 675LT" },
            { value: "McLaren 720S", text: "McLaren 720S" },
            { value: "McLaren 765LT", text: "McLaren 765LT" },
            { value: "McLaren Artura", text: "McLaren Artura" },
            { value: "McLaren GT", text: "McLaren GT" },
            { value: "McLaren MP4 12C", text: "McLaren MP4 12C" },
            { value: "McLaren P1", text: "McLaren P1" },
            { value: "McLaren Senna", text: "McLaren Senna" },
      ],
      Morris: [
            { value: "Morris", text: "Morris" },
      ],
      Nash: [
            { value: "Nash", text: "Nash" },
      ],
      Oshkosh: [
            { value: "Oshkosh", text: "Oshkosh" },
      ],
      PaceArrow: [
            { value: "Pace Arrow", text: "Pace Arrow" },
      ],
      Packard: [
            { value: "Packard", text: "Packard" },
      ],
      Pantera: [
            { value: "Pantera", text: "Pantera" },
      ],
      Peterbilt: [
            { value: "Peterbilt", text: "Peterbilt" },
      ],
      Polestar: [
            { value: "Polestar 1", text: "Polestar 1" },
            { value: "Polestar 2", text: "Polestar 2" },
      ],
      Ram: [
            { value: "Ram Promaster 1500", text: "Ram Promaster 1500" },
            { value: "Ram Promaster 2500", text: "Ram Promaster 2500" },
            { value: "Ram Promaster 3500", text: "Ram Promaster 3500" },
            { value: "Ram Promaster City", text: "Ram Promaster City" },
            { value: "Ram Truck 1500 Series", text: "Ram Truck 1500 Series" },
            { value: "Ram Truck 2500 Series", text: "Ram Truck 2500 Series" },
            { value: "Ram Truck 3500 Series", text: "Ram Truck 3500 Series" },
            { value: "Ram Truck 4500 Series", text: "Ram Truck 4500 Series" },
            { value: "Ram Truck 5500 Series", text: "Ram Truck 5500 Series" },
      ],
      REO: [
            { value: "REO", text: "REO" },
      ],
      Rivian: [
            { value: "Rivian R1S", text: "Rivian R1S" },
            { value: "Rivian R1T", text: "Rivian R1T" },
      ],
      RollsRoyce: [
            { value: "RollsRoyce", text: "RollsRoyce" },
      ],
      Rover: [
            { value: "Rover 3 Litre", text: "Rover 3 Litre" },
            { value: "Rover 100", text: "Rover 100" },
            { value: "Rover 2000", text: "Rover 2000" },
            { value: "Rover 3500", text: "Rover 3500" },
            { value: "Rover 3500S", text: "Rover 3500S" },
      ],
      Seat: [
            { value: "Seat Cordova", text: "Seat Cordova" },
            { value: "Seat Ibiza", text: "Seat Ibiza" },
            { value: "Seat Leon", text: "Seat Leon" },
            { value: "Seat Toledo", text: "Seat Toledo" },
      ],
      Simca: [
            { value: "Simca", text: "Simca" },
      ],
      SmartFortwo: [
            { value: "Smart Fortwo", text: "Smart Fortwo" },
      ],
      SterlingRover: [
            { value: "SterlingRover", text: "SterlingRover" },
      ],
      Studebaker: [
            { value: "Studebaker", text: "Studebaker" },
      ],
      Sunbeam: [
            { value: "Sunbeam", text: "Sunbeam" },
      ],
      Tesla: [
            { value: "Tesla Model 3", text: "Tesla Model 3" },
            { value: "Tesla Model S", text: "Tesla Model S" },
            { value: "Tesla Model X", text: "Tesla Model X" },
            { value: "Tesla Model Y", text: "Tesla Model Y" },
            { value: "Tesla Roadster", text: "Tesla Roadster" },
      ],
      ThomasTruck: [
            { value: "Thomas Truck", text: "Thomas Truck" },
      ],
      Utilimaster: [
            { value: "Utilimaster Step Van", text: "Utilimaster Step Van" },
      ],
      VPGMV1: [
            { value: "VPG MV1", text: "VPG MV1" },
      ],
      WesternStar: [
            { value: "Western Star", text: "Western Star" },
      ],
      White: [
            { value: "White", text: "White" },
      ],
      Willys: [
            { value: "Willys", text: "Willys" },
      ],
      Winnebago: [
            { value: "Winnebago", text: "Winnebago" },
      ],
      Yugo: [
            { value: "Yugo", text: "Yugo" },
      ]
    };

    // Effect to update models when make changes
    useEffect(() => {
        if (make) {
            setModels(modelsByMake[make] || []);
            setModel(''); // Reset model when make changes
        } else {
            setModels([]);
        }
    }, [make]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Send the email via the PHP backend server
            const formData = new FormData();
            formData.append('part', part);
            formData.append('make', make);
            formData.append('model', model);
            formData.append('year', year);
            formData.append('name', name);
            formData.append('email', email);
            formData.append('phone', phone);
            formData.append('zipcode', zipcode);
            formData.append('comment', comment);

            const response = await fetch('https://staging.motortiger.com/super-files/email.php', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                navigate('/thank-you');
            } else {
                console.error('Error sending email');
            }
        } catch (error) {
            console.error('Error sending email:', error);
        }
    };

  return (
    <div className="site-primary" id="main">
    <div className="site-content" id="content">
      <div
        data-elementor-type="wp-page"
        data-elementor-id={5040}
        className="elementor elementor-5040"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-2888587 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id={2888587}
          data-element_type="section"
          data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-a560db1"
              data-id="a560db1"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-2da9094 elementor-widget elementor-widget-spacer"
                  data-id="2da9094"
                  data-element_type="widget"
                  data-widget_type="spacer.default"
                >
                  <div className="elementor-widget-container">
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                .elementor-column .elementor-spacer-inner {\n                                                    height: var(--spacer-size)\n                                                }\n\n                                                .e-con {\n                                                    --container-widget-width: 100%\n                                                }\n\n                                                .e-con-inner>.elementor-widget-spacer,\n                                                .e-con>.elementor-widget-spacer {\n                                                    width: var(--container-widget-width, var(--spacer-size));\n                                                    --align-self: var(--container-widget-align-self, initial);\n                                                    --flex-shrink: 0\n                                                }\n\n                                                .e-con-inner>.elementor-widget-spacer>.elementor-widget-container,\n                                                .e-con>.elementor-widget-spacer>.elementor-widget-container {\n                                                    height: 100%;\n                                                    width: 100%\n                                                }\n\n                                                .e-con-inner>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer,\n                                                .e-con>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer {\n                                                    height: 100%\n                                                }\n\n                                                .e-con-inner>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer>.elementor-spacer-inner,\n                                                .e-con>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer>.elementor-spacer-inner {\n                                                    height: var(--container-widget-height, var(--spacer-size))\n                                                }\n\n                                                .e-con-inner>.elementor-widget-spacer.elementor-widget-empty,\n                                                .e-con>.elementor-widget-spacer.elementor-widget-empty {\n                                                    position: relative;\n                                                    min-height: 22px;\n                                                    min-width: 22px\n                                                }\n\n                                                .e-con-inner>.elementor-widget-spacer.elementor-widget-empty .elementor-widget-empty-icon,\n                                                .e-con>.elementor-widget-spacer.elementor-widget-empty .elementor-widget-empty-icon {\n                                                    position: absolute;\n                                                    top: 0;\n                                                    bottom: 0;\n                                                    left: 0;\n                                                    right: 0;\n                                                    margin: auto;\n                                                    padding: 0;\n                                                    width: 22px;\n                                                    height: 22px\n                                                }\n                                            "
                      }}
                    />
                    <div className="elementor-spacer">
                      <div className="elementor-spacer-inner" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-cc5723b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="cc5723b"
          data-element_type="section"
          data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-809c10e"
              data-id="809c10e"
              data-element_type="column"
              data-settings='{"background_background":"classic"}'
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-813bf99 elementor-widget elementor-widget-heading"
                  data-id="813bf99"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                .elementor-heading-title {\n                                                    padding: 0;\n                                                    margin: 0;\n                                                    line-height: 1\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title[class*=elementor-size-]>a {\n                                                    color: inherit;\n                                                    font-size: inherit;\n                                                    line-height: inherit\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-small {\n                                                    font-size: 15px\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-medium {\n                                                    font-size: 19px\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-large {\n                                                    font-size: 29px\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-xl {\n                                                    font-size: 39px\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-xxl {\n                                                    font-size: 59px\n                                                }\n                                            "
                      }}
                    />
                    <h2 className="elementor-heading-title elementor-size-default">
                      FIND YOUR CAR PARTS
                    </h2>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-32e2c46 elementor-widget elementor-widget-formidable"
                  data-id="32e2c46"
                  data-element_type="widget"
                  data-widget_type="formidable.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="frm_forms  with_frm_style frm_style_formidable-style"
                      id="frm_form_4_container"
                    >
                      <form id="motortigerForm" method="POST" className="frm-show-form" onSubmit={handleSubmit}>
                          <div className="frm_form_fields">
                              <fieldset>
                                  <legend className="frm_screen_reader">Motortiger</legend>
                                  <div className="frm_fields_container">
                                      <div className="frm_fields_container">
                                          <div id="frm_field_30_container" className="frm_form_field form-field frm_top_container frm6 frm_first">
                                              <label htmlFor="field_1308q" className="frm_primary_label">
                                                  Which Part?
                                                  <span className="frm_required">*</span>
                                              </label>
                                              <select name="part" id="field_1308q" required value={part} onChange={(e) => setPart(e.target.value)}>
                                                  <option value="- Select Option -">- Select Option -</option>
                                                  <option value="Engine">Engine</option>
                                                  <option value="Transmission">Transmission</option>
                                              </select>
                                          </div>
                                          <div id="frm_field_21_container" className="frm_form_field form-field frm_required_field frm_top_container frm6">
                                              <label htmlFor="field_qf7dy" className="frm_primary_label">
                                                  Make
                                                  <span className="frm_required">*</span>
                                              </label>
                                              <select name="make" id="field_qf7dy" required value={make} onChange={(e) => setMake(e.target.value)}>
                                                  <option value="- Select Option -">- Select Option -</option>
                                                  <option value="Acura">Acura</option>
                                                  <option value="Alfa">Alfa</option>
                                                  <option value="AMC">AMC</option>
                                                  <option value="Audi">Audi</option>
                                                  <option value="BMW">BMW</option>
                                                  <option value="Buick">Buick</option>
                                                  <option value="Cadillac">Cadillac</option>
                                                  <option value="Chevy">Chevy</option>
                                                  <option value="Chrysler">Chrysler</option>
                                                  <option value="Daewoo">Daewoo</option>
                                                  <option value="Daihatsu">Daihatsu</option>
                                                  <option value="Dodge">Dodge</option>
                                                  <option value="Eagle">Eagle</option>
                                                  <option value="Fiat">Fiat</option>
                                                  <option value="Ford">Ford</option>
                                                  <option value="Geo">Geo</option>
                                                  <option value="GMC">GMC</option>
                                                  <option value="Honda">Honda</option>
                                                  <option value="Hummer">Hummer</option>
                                                  <option value="Hyundai">Hyundai</option>
                                                  <option value="Infiniti">Infiniti</option>
                                                  <option value="Isuzu">Isuzu</option>
                                                  <option value="Jaguar">Jaguar</option>
                                                  <option value="Jeep">Jeep</option>
                                                  <option value="Kia">Kia</option>
                                                  <option value="LandRover">LandRover</option>
                                                  <option value="Lexus">Lexus</option>
                                                  <option value="Lincoln">Lincoln</option>
                                                  <option value="Mazda">Mazda</option>
                                                  <option value="Mercedes">Mercedes</option>
                                                  <option value="Mercury">Mercury</option>
                                                  <option value="Mini">Mini</option>
                                                  <option value="Mitsubishi">Mitsubishi</option>
                                                  <option value="Nissan">Nissan</option>
                                                  <option value="Oldsmobile">Oldsmobile</option>
                                                  <option value="Opel">Opel</option>
                                                  <option value="Peugeot">Peugeot</option>
                                                  <option value="Plymouth">Plymouth</option>
                                                  <option value="Pontiac">Pontiac</option>
                                                  <option value="Porsche">Porsche</option>
                                                  <option value="Renault">Renault</option>
                                                  <option value="Saab">Saab</option>
                                                  <option value="Saturn">Saturn</option>
                                                  <option value="Scion">Scion</option>
                                                  <option value="Subaru">Subaru</option>
                                                  <option value="Suzuki">Suzuki</option>
                                                  <option value="Toyota">Toyota</option>
                                                  <option value="Triumph">Triumph</option>
                                                  <option value="Volkswagen">Volkswagen</option>
                                                  <option value="Volvo">Volvo</option>
                                              </select>
                                          </div>
                                          <div id="frm_field_23_container" className="frm_form_field form-field frm_required_field frm_top_container frm6 frm_first">
                                              <label htmlFor="field_fv3r1" className="frm_primary_label">
                                                  Model
                                                  <span className="frm_required" aria-hidden="true">*</span>
                                              </label>
                                              <select name="model" id="field_fv3r1" required value={model} onChange={(e) => setModel(e.target.value)}>
                                                  <option value="- Select Model -">- Select Model -</option>
                                                  {models.map((model) => (
                                                      <option key={model.value} value={model.value}>{model.text}</option>
                                                  ))}
                                              </select>
                                          </div>
                                          <div id="frm_field_22_container" className="frm_form_field form-field frm_required_field frm_top_container frm6">
                                              <label htmlFor="field_69q1x" className="frm_primary_label">
                                                  Year
                                                  <span className="frm_required" aria-hidden="true">*</span>
                                              </label>
                                              <select name="year" id="field_69q1x" required value={year} onChange={(e) => setYear(e.target.value)}>
                                                  <option value="- Select Year-">- Select Year-</option>
                                                  <option value={2025}>2025</option>
                                                  <option value={2024}>2024</option>
                                                  <option value={2023}>2023</option>
                                                  <option value={2022}>2022</option>
                                                  <option value={2021}>2021</option>
                                                  <option value={2020}>2020</option>
                                                  <option value={2019}>2019</option>
                                                  <option value={2018}>2018</option>
                                                  <option value={2017}>2017</option>
                                                  <option value={2016}>2016</option>
                                                  <option value={2015}>2015</option>
                                                  <option value={2014}>2014</option>
                                                  <option value={2013}>2013</option>
                                                  <option value={2012}>2012</option>
                                                  <option value={2011}>2011</option>
                                                  <option value={2010}>2010</option>
                                                  <option value={2009}>2009</option>
                                                  <option value={2008}>2008</option>
                                                  <option value={2007}>2007</option>
                                                  <option value={2006}>2006</option>
                                                  <option value={2005}>2005</option>
                                                  <option value={2004}>2004</option>
                                                  <option value={2003}>2003</option>
                                                  <option value={2002}>2002</option>
                                                  <option value={2001}>2001</option>
                                                  <option value={2000}>2000</option>
                                                  <option value={1999}>1999</option>
                                                  <option value={1998}>1998</option>
                                                  <option value={1997}>1997</option>
                                                  <option value={1996}>1996</option>
                                                  <option value={1995}>1995</option>
                                                  <option value={1994}>1994</option>
                                                  <option value={1993}>1993</option>
                                                  <option value={1992}>1992</option>
                                                  <option value={1991}>1991</option>
                                                  <option value={1990}>1990</option>
                                                  <option value={1989}>1989</option>
                                                  <option value={1988}>1988</option>
                                                  <option value={1987}>1987</option>
                                                  <option value={1986}>1986</option>
                                                  <option value={1985}>1985</option>
                                                  <option value={1984}>1984</option>
                                                  <option value={1983}>1983</option>
                                                  <option value={1982}>1982</option>
                                                  <option value={1981}>1981</option>
                                                  <option value={1980}>1980</option>
                                                  <option value={1979}>1979</option>
                                                  <option value={1978}>1978</option>
                                                  <option value={1977}>1977</option>
                                                  <option value={1976}>1976</option>
                                                  <option value={1975}>1975</option>
                                                  <option value={1974}>1974</option>
                                                  <option value={1973}>1973</option>
                                                  <option value={1972}>1972</option>
                                                  <option value={1971}>1971</option>
                                                  <option value={1970}>1970</option>
                                                  <option value={1969}>1969</option>
                                                  <option value={1968}>1968</option>
                                                  <option value={1967}>1967</option>
                                                  <option value={1966}>1966</option>
                                                  <option value={1965}>1965</option>
                                                  <option value={1964}>1964</option>
                                                  <option value={1963}>1963</option>
                                                  <option value={1962}>1962</option>
                                                  <option value={1961}>1961</option>
                                                  <option value={1960}>1960</option>
                                                  <option value={1959}>1959</option>
                                                  <option value={1958}>1958</option>
                                                  <option value={1957}>1957</option>
                                                  <option value={1956}>1956</option>
                                                  <option value={1955}>1955</option>
                                                  <option value={1954}>1954</option>
                                                  <option value={1953}>1953</option>
                                                  <option value={1952}>1952</option>
                                                  <option value={1951}>1951</option>
                                                  <option value={1950}>1950</option>
                                                  <option value={1949}>1949</option>
                                                  <option value={1948}>1948</option>
                                                  <option value={1947}>1947</option>
                                                  <option value={1946}>1946</option>
                                                  <option value={1945}>1945</option>
                                                  <option value={1944}>1944</option>
                                                  <option value={1943}>1943</option>
                                                  <option value={1942}>1942</option>
                                                  <option value={1941}>1941</option>
                                                  <option value={1940}>1940</option>
                                                  <option value={1939}>1939</option>
                                                  <option value={1938}>1938</option>
                                                  <option value={1937}>1937</option>
                                                  <option value={1936}>1936</option>
                                                  <option value={1935}>1935</option>
                                                  <option value={1934}>1934</option>
                                                  <option value={1933}>1933</option>
                                                  <option value={1932}>1932</option>
                                                  <option value={1931}>1931</option>
                                                  <option value={1930}>1930</option>
                                                  <option value={1929}>1929</option>
                                                  <option value={1928}>1928</option>
                                                  <option value={1927}>1927</option>
                                                  <option value={1926}>1926</option>
                                                  <option value={1925}>1925</option>
                                                  <option value={1924}>1924</option>
                                                  <option value={1923}>1923</option>
                                                  <option value={1922}>1922</option>
                                                  <option value={1921}>1921</option>
                                                  <option value={1920}>1920</option>
                                                  <option value={1919}>1919</option>
                                                  <option value={1918}>1918</option>
                                                  <option value={1917}>1917</option>
                                                  <option value={1916}>1916</option>
                                                  <option value={1915}>1915</option>
                                                  <option value={1914}>1914</option>
                                                  <option value={1913}>1913</option>
                                                  <option value={1912}>1912</option>
                                                  <option value={1911}>1911</option>
                                                  <option value={1910}>1910</option>
                                                  <option value={1909}>1909</option>
                                                  <option value={1908}>1908</option>
                                                  <option value={1907}>1907</option>
                                                  <option value={1906}>1906</option>
                                                  <option value={1905}>1905</option>
                                                  <option value={1904}>1904</option>
                                                  <option value={1903}>1903</option>
                                                  <option value={1902}>1902</option>
                                                  <option value={1901}>1901</option>
                                                  <option value={1900}>1900</option>
                                              </select>
                                          </div>

                                          <div id="frm_field_29_container" className="frm_form_field form-field frm_required_field frm_top_container frm6">
                                              <label htmlFor="field_dzldo" className="frm_primary_label">
                                                  Name
                                                  <span className="frm_required">*</span>
                                              </label>
                                              <input type="text" id="field_dzldo" name="name" required value={name} onChange={(e) => setName(e.target.value)} />
                                          </div>
                                          <div id="frm_field_28_container" className="frm_form_field form-field frm_required_field frm_top_container frm6">
                                              <label htmlFor="field_h6mru" className="frm_primary_label">
                                                  Email
                                                  <span className="frm_required">*</span>
                                              </label>
                                              <input type="email" id="field_h6mru" name="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                                          </div>
                                          <div id="frm_field_26_container" className="frm_form_field form-field frm_required_field frm_top_container frm6">
                                              <label htmlFor="field_k4wji" className="frm_primary_label">
                                                  Phone
                                                  <span className="frm_required">*</span>
                                              </label>
                                              <input type="tel" id="field_k4wji" name="phone" required pattern="[0-9]{10}" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                          </div>
                                          <div id="frm_field_31_container" className="frm_form_field form-field frm_top_container frm6">
                                              <label htmlFor="field_erq06" className="frm_primary_label">
                                                  Zip Code
                                              </label>
                                              <input type="text" id="field_erq06" name="zipcode" pattern="[0-9]{5,6}" value={zipcode} onChange={(e) => setZipcode(e.target.value)} />
                                          </div>
                                          <div id="frm_field_32_container" className="frm_form_field form-field frm_top_container frm12">
                                              <label htmlFor="field_comment" className="frm_primary_label">
                                                  Comment
                                              </label>
                                              <input type="text" id="field_comment" name="comment" placeholder="Add your comment here" value={comment} onChange={(e) => setComment(e.target.value)} />
                                          </div>

                                          <div className="frm_submit">
                                              <button type="submit" className="frm_button_submit">Submit</button>
                                          </div>
                                      </div>
                                  </div>
                              </fieldset>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-e761faa"
              data-id="e761faa"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-3dacd5d elementor-widget elementor-widget-partdo-home-slider"
                  data-id="3dacd5d"
                  data-element_type="widget"
                  data-widget_type="partdo-home-slider.default"
                >
                  <div className="elementor-widget-container">
                    <div className="owl-carousel">
                      <div className="item">
                        <img
                          src="assets/images/slide-img-1.jpg"
                          alt="Image 2"
                        />
                        <div className="content">
                            <h4 class="entry-subtitle"> Used Auto
                                Parts Across Every State</h4>
                            <h2 class="entry-title font-large-md">
                                Extensive Nationwide Inventory</h2>
                        </div>
                      </div>
                      <div className="item">
                        <img
                          src="assets/images/slide-img-2.jpg"
                          alt="Image 3"
                        />
                        <div className="content">

                            <h4 class="entry-subtitle">Excellence In
                                Every Auto Parts.</h4>
                            <h2 class="entry-title font-large-md">
                                100% Quality Assurance. </h2>
                        </div>
                      </div>
                      <div className="item">
                        <img
                          src="assets/images/slide-img-3.jpg"
                          alt="Image 4"
                        />
                        <div className="content">
                            <h4 class="entry-subtitle">Tailored For
                                Your Budget &amp; Preferences</h4>
                            <h2 class="entry-title font-large-md">
                                Economical Pricing &amp;
                                Personalised Deals </h2>
                        </div>
                      </div>
                      <div className="item">
                        <img
                          src="assets/images/slide-img-4.jpg"
                          alt="Image 5"
                        />
                        <div className="content">
                            <h4 class="entry-subtitle"> Get your
                                order In No Time At Your Place.</h4>
                            <h2 class="entry-title font-large-md">No
                                Cost Shipping-Lightning Fast
                                Delivery.</h2>
                        </div>
                      </div>
                      <div className="item">
                        <img
                          src="assets/images/slide-img-5.jpg"
                          alt="Image 6"
                        />
                        <div className="content">
                            <h4 class="entry-subtitle">Our Promise
                                To You.</h4>
                            <h2 class="entry-title font-large-md">
                                Successfully Delivering The After
                                Sales Commitments</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-f2e34d4 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="f2e34d4"
          data-element_type="section"
          data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6232c39"
              data-id="6232c39"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-1526d30 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="1526d30"
                  data-element_type="section"
                  data-settings='{"_ha_eqh_enable":"yes","_ha_eqh_widget":["image"],"_ha_eqh_to":"widget","_ha_eqh_disable_on_tablet":"no","_ha_eqh_disable_on_mobile":"yes"}'
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-23a12ca"
                      data-id="23a12ca"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-b313690 elementor-widget elementor-widget-image"
                          data-id="b313690"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container">
                            <style
                              dangerouslySetInnerHTML={{
                                __html:
                                  '\n                                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                                .elementor-widget-image {\n                                                                    text-align: center\n                                                                }\n\n                                                                .elementor-widget-image a {\n                                                                    display: inline-block\n                                                                }\n\n                                                                .elementor-widget-image a img[src$=".svg"] {\n                                                                    width: 48px\n                                                                }\n\n                                                                .elementor-widget-image img {\n                                                                    vertical-align: middle;\n                                                                    display: inline-block\n                                                                }\n                                                            '
                              }}
                            />{" "}
                            <img
                              decoding="async"
                              width={234}
                              height={161}
                              src="assets/files/uploads/2024/02/Group-88-1.png"
                              className="attachment-large size-large wp-image-4729"
                              alt=""
                              srcSet="assets/files/uploads/2024/02/Group-88-1.png 234w, assets/files/uploads/2024/02/Group-88-1-78x54.png 78w"
                              sizes="(max-width: 234px) 100vw, 234px"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-31595f4"
                      data-id="31595f4"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-4f855b9 elementor-widget elementor-widget-image"
                          data-id="4f855b9"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container">
                            <img
                              decoding="async"
                              width={234}
                              height={161}
                              src="assets/files/uploads/2024/02/Group-87-1.png"
                              className="attachment-large size-large wp-image-4730"
                              alt=""
                              srcSet="assets/files/uploads/2024/02/Group-87-1.png 234w, assets/files/uploads/2024/02/Group-87-1-78x54.png 78w"
                              sizes="(max-width: 234px) 100vw, 234px"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-941d07d"
                      data-id="941d07d"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-d02aa81 elementor-widget elementor-widget-image"
                          data-id="d02aa81"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container">
                            <img
                              decoding="async"
                              width={234}
                              height={161}
                              src="assets/files/uploads/2024/02/Group-86-1.png"
                              className="attachment-large size-large wp-image-4731"
                              alt=""
                              srcSet="assets/files/uploads/2024/02/Group-86-1.png 234w, assets/files/uploads/2024/02/Group-86-1-78x54.png 78w"
                              sizes="(max-width: 234px) 100vw, 234px"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-f7f83aa elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="f7f83aa"
          data-element_type="section"
          data-settings='{"_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2d1ba55"
              data-id="2d1ba55"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-97f3389 elementor-widget elementor-widget-text-editor"
                  data-id="97f3389"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                .elementor-widget-text-editor.elementor-drop-cap-view-stacked .elementor-drop-cap {\n                                                    background-color: #69727d;\n                                                    color: #fff\n                                                }\n\n                                                .elementor-widget-text-editor.elementor-drop-cap-view-framed .elementor-drop-cap {\n                                                    color: #69727d;\n                                                    border: 3px solid;\n                                                    background-color: transparent\n                                                }\n\n                                                .elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap {\n                                                    margin-top: 8px\n                                                }\n\n                                                .elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap-letter {\n                                                    width: 1em;\n                                                    height: 1em\n                                                }\n\n                                                .elementor-widget-text-editor .elementor-drop-cap {\n                                                    float: left;\n                                                    text-align: center;\n                                                    line-height: 1;\n                                                    font-size: 50px\n                                                }\n\n                                                .elementor-widget-text-editor .elementor-drop-cap-letter {\n                                                    display: inline-block\n                                                }\n                                            "
                      }}
                    />
                    <p>
                      Welcome to Motortiger Inc.&nbsp;
                      <br />
                      Your Premier Destination for Quality Used Engines,
                      <br />
                      Transmissions, and Auto Spare Parts
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-2340604 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id={2340604}
          data-element_type="section"
          data-settings='{"_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-d85a014"
              data-id="d85a014"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-3872a41 elementor-position-top elementor-widget elementor-widget-image-box"
                  data-id="3872a41"
                  data-element_type="widget"
                  data-widget_type="image-box.default"
                >
                  <div className="elementor-widget-container">
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                .elementor-widget-image-box .elementor-image-box-content {\n                                                    width: 100%\n                                                }\n\n                                                @media (min-width:768px) {\n\n                                                    .elementor-widget-image-box.elementor-position-left .elementor-image-box-wrapper,\n                                                    .elementor-widget-image-box.elementor-position-right .elementor-image-box-wrapper {\n                                                        display: flex\n                                                    }\n\n                                                    .elementor-widget-image-box.elementor-position-right .elementor-image-box-wrapper {\n                                                        text-align: end;\n                                                        flex-direction: row-reverse\n                                                    }\n\n                                                    .elementor-widget-image-box.elementor-position-left .elementor-image-box-wrapper {\n                                                        text-align: start;\n                                                        flex-direction: row\n                                                    }\n\n                                                    .elementor-widget-image-box.elementor-position-top .elementor-image-box-img {\n                                                        margin: auto\n                                                    }\n\n                                                    .elementor-widget-image-box.elementor-vertical-align-top .elementor-image-box-wrapper {\n                                                        align-items: flex-start\n                                                    }\n\n                                                    .elementor-widget-image-box.elementor-vertical-align-middle .elementor-image-box-wrapper {\n                                                        align-items: center\n                                                    }\n\n                                                    .elementor-widget-image-box.elementor-vertical-align-bottom .elementor-image-box-wrapper {\n                                                        align-items: flex-end\n                                                    }\n                                                }\n\n                                                @media (max-width:767px) {\n                                                    .elementor-widget-image-box .elementor-image-box-img {\n                                                        margin-left: auto !important;\n                                                        margin-right: auto !important;\n                                                        margin-bottom: 15px\n                                                    }\n                                                }\n\n                                                .elementor-widget-image-box .elementor-image-box-img {\n                                                    display: inline-block\n                                                }\n\n                                                .elementor-widget-image-box .elementor-image-box-title a {\n                                                    color: inherit\n                                                }\n\n                                                .elementor-widget-image-box .elementor-image-box-wrapper {\n                                                    text-align: center\n                                                }\n\n                                                .elementor-widget-image-box .elementor-image-box-description {\n                                                    margin: 0\n                                                }\n                                            "
                      }}
                    />
                    <div className="elementor-image-box-wrapper">
                      <figure className="elementor-image-box-img">
                        <a href="/used-engines" tabIndex={-1}>
                          <img
                            loading="lazy"
                            decoding="async"
                            width={400}
                            height={296}
                            src="assets/files/uploads/2024/02/300-engine-assembly.png"
                            className="attachment-full size-full wp-image-4311"
                            alt=""
                            srcSet="assets/files/uploads/2024/02/300-engine-assembly.png 400w, assets/files/uploads/2024/02/300-engine-assembly-73x54.png 73w, assets/files/uploads/2024/02/300-engine-assembly-300x222.png 300w"
                            sizes="(max-width: 400px) 100vw, 400px"
                          />
                        </a>
                      </figure>
                      <div className="elementor-image-box-content">
                        <h3 className="elementor-image-box-title">
                          <a href="/used-engines">Used Engines</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-f0a22e2"
              data-id="f0a22e2"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-b415e8f elementor-position-top elementor-widget elementor-widget-image-box"
                  data-id="b415e8f"
                  data-element_type="widget"
                  data-widget_type="image-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-image-box-wrapper">
                      <figure className="elementor-image-box-img">
                        <a href="/used-transmissions" tabIndex={-1}>
                          <img
                            loading="lazy"
                            decoding="async"
                            width={400}
                            height={296}
                            src="assets/files/uploads/2024/02/400-transmission-assembly.png"
                            className="attachment-full size-full wp-image-4312"
                            alt=""
                            srcSet="assets/files/uploads/2024/02/400-transmission-assembly.png 400w, assets/files/uploads/2024/02/400-transmission-assembly-73x54.png 73w, assets/files/uploads/2024/02/400-transmission-assembly-300x222.png 300w"
                            sizes="(max-width: 400px) 100vw, 400px"
                          />
                        </a>
                      </figure>
                      <div className="elementor-image-box-content">
                        <h3 className="elementor-image-box-title">
                          <a href="/used-transmissions">
                            Used Transmissions
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-aeb60fd"
              data-id="aeb60fd"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-c67e93b elementor-position-top elementor-widget elementor-widget-image-box"
                  data-id="c67e93b"
                  data-element_type="widget"
                  data-widget_type="image-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-image-box-wrapper">
                      <figure className="elementor-image-box-img">
                        <a href="/used-auto-spare-parts" tabIndex={-1}>
                          <img
                            loading="lazy"
                            decoding="async"
                            width={600}
                            height={427}
                            src="assets/files/uploads/2024/02/p-parts.png"
                            className="attachment-full size-full wp-image-4313"
                            alt=""
                            srcSet="assets/files/uploads/2024/02/p-parts.png 600w, assets/files/uploads/2024/02/p-parts-76x54.png 76w, assets/files/uploads/2024/02/p-parts-300x214.png 300w"
                            sizes="(max-width: 600px) 100vw, 600px"
                          />
                        </a>
                      </figure>
                      <div className="elementor-image-box-content">
                        <h3 className="elementor-image-box-title">
                          <a href="/used-auto-spare-parts">
                            Used Auto Spare Parts
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-0b39a6c"
              data-id="0b39a6c"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-21b667d elementor-position-top elementor-widget elementor-widget-image-box"
                  data-id="21b667d"
                  data-element_type="widget"
                  data-widget_type="image-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-image-box-wrapper">
                      <figure className="elementor-image-box-img">
                        <a href="/rebuilt-engines" tabIndex={-1}>
                          <img
                            loading="lazy"
                            decoding="async"
                            width={258}
                            height={196}
                            src="assets/files/uploads/2024/02/download.jpg"
                            className="attachment-full size-full wp-image-4739"
                            alt=""
                            srcSet="assets/files/uploads/2024/02/download.jpg 258w, assets/files/uploads/2024/02/download-71x54.jpg 71w"
                            sizes="(max-width: 258px) 100vw, 258px"
                          />
                        </a>
                      </figure>
                      <div className="elementor-image-box-content">
                        <h3 className="elementor-image-box-title">
                          <a href="/rebuilt-engines">Rebuilt Engines</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-338c763"
              data-id="338c763"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-7ff83ed elementor-position-top elementor-widget elementor-widget-image-box"
                  data-id="7ff83ed"
                  data-element_type="widget"
                  data-widget_type="image-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-image-box-wrapper">
                      <figure className="elementor-image-box-img">
                        <a href="/rebuilt-transmissions" tabIndex={-1}>
                          <img
                            loading="lazy"
                            decoding="async"
                            width={400}
                            height={296}
                            src="assets/files/uploads/2024/02/400-transmission-assembly.png"
                            className="attachment-full size-full wp-image-4312"
                            alt=""
                            srcSet="assets/files/uploads/2024/02/400-transmission-assembly.png 400w, assets/files/uploads/2024/02/400-transmission-assembly-73x54.png 73w, assets/files/uploads/2024/02/400-transmission-assembly-300x222.png 300w"
                            sizes="(max-width: 400px) 100vw, 400px"
                          />
                        </a>
                      </figure>
                      <div className="elementor-image-box-content">
                        <h3 className="elementor-image-box-title">
                          <a href="/rebuilt-transmissions">
                            Rebuilt Transmissions
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-aaf31f7 elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
          data-id="aaf31f7"
          data-element_type="section"
          data-settings='{"background_background":"classic","shape_divider_top":"waves","_ha_eqh_enable":false}'
        >
          <div
            className="elementor-shape elementor-shape-top"
            data-negative="false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1000 100"
              preserveAspectRatio="none"
            >
              <path
                className="elementor-shape-fill"
                d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
  c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
  c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"
              />
            </svg>
          </div>
          <section className="brands-section">
            <div className="container container-extra-custom">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h6 className="sub-heading">Popular</h6>
                  <h2 className="heading heading-dark text-uppercase text-blue">
                    Brands
                  </h2>
                  <p className="desc">
                    MotorTiger is one of the trusted and renowned online
                    provider of used auto parts
                  </p>
                </div>
              </div>
              <div className="brand-slider brand_box">
                <div className="brand_box-inner">
                  <div className="brand-li">
                    <a href="#" data-brand="Porsche">
                      <img src="assets/images/brands/1.png" alt="Porsche" />
                      <span>Porsche</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-nissan-engines.php" data-brand="Nissan">
                      <img src="assets/images/brands/2.png" alt="Nissan" />
                      <span>Nissan</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a
                      href="used-mitsubishi-engines.php"
                      data-brand="Mitsubishi"
                    >
                      <img src="assets/images/brands/3.png" alt="Mitsubishi" />
                      <span>Mitsubishi</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-mini-cooper-engines.php" data-brand="Mini">
                      <img src="assets/images/brands/4.png" alt="Mini" />
                      <span>Mini</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-mercedes-engines.php" data-brand="Mercedes">
                      <img src="assets/images/brands/5.png" alt="Mercedes" />
                      <span>Mercedes</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Land Rover">
                      <img src="assets/images/brands/6.png" alt="Land Rover" />
                      <span>Land Rover</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-kia-engines.php" data-brand="Kia">
                      <img src="assets/images/brands/7.png" alt="Kia" />
                      <span>Kia</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-hyundai-engines.php" data-brand="Hyundai">
                      <img src="assets/images/brands/8.png" alt="Hyundai" />
                      <span>Hyundai</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Geo">
                      <img src="assets/images/brands/9.png" alt="Geo" />
                      <span>Geo</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Datsun">
                      <img src="assets/images/brands/10.png" alt="Datsun" />
                      <span>Datsun</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Daihatsu">
                      <img src="assets/images/brands/11.png" alt="Daihatsu" />
                      <span>Daihatsu</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-audi-engines.php" data-brand="Audi">
                      <img src="assets/images/brands/12.png" alt="Audi" />
                      <span>Audi</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-bmw-engines.php" data-brand="BMW">
                      <img src="assets/images/brands/13.png" alt="BMW" />
                      <span>BMW</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Alfa Romeo">
                      <img src="assets/images/brands/14.png" alt="Alfa Romeo" />
                      <span>Alfa Romeo</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-acura-engines.php" data-brand="Acura">
                      <img src="assets/images/brands/15.png" alt="Acura" />
                      <span>Acura</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-honda-engines.php" data-brand="Honda">
                      <img src="assets/images/brands/16.png" alt="Honda" />
                      <span>Honda</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Jaguar">
                      <img src="assets/images/brands/17.png" alt="Jaguar" />
                      <span>Jaguar</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-infiniti-engines.php" data-brand="Infiniti">
                      <img src="assets/images/brands/18.png" alt="Infiniti" />
                      <span>Infiniti</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Daewoo">
                      <img src="assets/images/brands/19.png" alt="Daewoo" />
                      <span>Daewoo</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-lexus-engines.php" data-brand="Lexus">
                      <img src="assets/images/brands/20.png" alt="Lexus" />
                      <span>Lexus</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-mazda-engines.php" data-brand="Mazda">
                      <img src="assets/images/brands/21.png" alt="Mazda" />
                      <span>Mazda</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Volvo">
                      <img src="assets/images/brands/22.png" alt="Volvo" />
                      <span>Volvo</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-toyota-engines.php" data-brand="Toyota">
                      <img src="assets/images/brands/23.png" alt="Toyota" />
                      <span>Toyota</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-suzuki-engines.php" data-brand="Suzuki">
                      <img src="assets/images/brands/24.png" alt="Suzuki" />
                      <span>Suzuki</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-subaru-engines.php" data-brand="Subaru">
                      <img src="assets/images/brands/25.png" alt="Subaru" />
                      <span>Subaru</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="#" data-brand="Scion">
                      <img src="assets/images/brands/26.png" alt="Scion" />
                      <span>Scion</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-saturn-engines.php" data-brand="Saturn">
                      <img src="assets/images/brands/27.png" alt="Saturn" />
                      <span>Saturn</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-chevy-engines.php" data-brand="Chevy">
                      <img src="assets/images/brands/chevy.png" alt="Chevy" />
                      <span>Chevy</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-buick-engines.php" data-brand="Buick">
                      <img
                        style={{ width: "50px !important" }}
                        src="assets/images/brands/Buick-logo.png"
                        alt="Buick"
                      />
                      <span>Buick</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-dodge-engines.php" data-brand="Dodge">
                      <img src="assets/images/brands/dodge.png" alt="Dodge" />
                      <span>Dodge</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-jeep-engines.php" data-brand="Jeep">
                      <img src="assets/images/brands/jeep.png" alt="Jeep" />
                      <span>Jeep</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-ford-engines.php" data-brand="Ford">
                      <img src="assets/images/brands/ford.png" alt="Ford" />
                      <span>Ford</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-gmc-engines.php" data-brand="GMC">
                      <img src="assets/images/brands/gmc.png" alt="GMC" />
                      <span>GMC</span>
                    </a>
                  </div>
                  <div className="brand-li">
                    <a href="used-hummer-engines.php" data-brand="Hummer">
                      <img src="assets/images/brands/hummer.png" alt="Hummer" />
                      <span>Hummer</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-699927e elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="699927e"
          data-element_type="section"
          data-settings='{"_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-extended">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-aaafbc3"
              data-id="aaafbc3"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4637390 elementor-widget elementor-widget-partdo-banner-box"
                  data-id={4637390}
                  data-element_type="widget"
                  data-widget_type="partdo-banner-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="klbth-banner style-inner color-scheme-light space-sm align-center justify-start hover-zoom">
                      <div className="entry-wrapper overlay-25-dark-max768 dump">
                        <div className="entry-inner w-50">
                          <div className="entry-heading banner-heading">
                            <span className="badge">Call Us Now</span>
                            <h2 className="entry-title font-banner-xlg">
                              +1 (877)-473-7675
                            </h2>
                          </div>
                          <div className="entry-excerpt font-sm weight-300">
                            <p>+1 (855) 253-1634</p>
                          </div>
                          <div className="entry-footer vertical banner-footer" />
                        </div>
                      </div>
                      <div className="entry-media overlay-15-dark-min768">
                        <img
                          decoding="async"
                          src="assets/files/uploads/2022/10/banner-07.jpg"
                          alt="slider image"
                        />
                      </div>
                      <a className="link-mask" href="index.html#">
                        {" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-e8daf39 elementor-section-full_width elementor-section-height-min-height elementor-section-height-default elementor-section-items-middle"
          data-id="e8daf39"
          data-element_type="section"
          data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-92532c3"
              data-id="92532c3"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-fccb370 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="fccb370"
                  data-element_type="section"
                  data-settings='{"_ha_eqh_enable":false}'
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-fc19af2"
                      data-id="fc19af2"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-602364c elementor-widget elementor-widget-image"
                          data-id="602364c"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container">
                            <img
                              loading="lazy"
                              decoding="async"
                              width={767}
                              height={687}
                              src="assets/files/uploads/2022/10/image-04-2.jpg"
                              className="attachment-large size-large wp-image-2600"
                              alt=""
                              srcSet="assets/files/uploads/2022/10/image-04-2.jpg 767w, assets/files/uploads/2022/10/image-04-2-60x54.jpg 60w, assets/files/uploads/2022/10/image-04-2-600x537.jpg 600w, assets/files/uploads/2022/10/image-04-2-300x269.jpg 300w"
                              sizes="(max-width: 767px) 100vw, 767px"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-fc706ec"
                      data-id="fc706ec"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-4d31dba elementor-widget elementor-widget-heading"
                          data-id="4d31dba"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              About Motor Tiger Inc
                            </h2>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-94cf564 elementor-widget elementor-widget-text-editor"
                          data-id="94cf564"
                          data-element_type="widget"
                          data-widget_type="text-editor.default"
                        >
                          <div className="elementor-widget-container">
                            <p>
                              Discover the Difference with Motor Tiger Inc– Your
                              Premier Source for OEM and Aftermarket Auto Parts!
                            </p>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-401f233 elementor-widget elementor-widget-text-editor"
                          data-id="401f233"
                          data-element_type="widget"
                          data-widget_type="text-editor.default"
                        >
                          <div className="elementor-widget-container">
                            <p>
                              As the largest online provider of Used
                              Transmissions, Used Engines, Rebuilt Engines, Used
                              Auto Parts, Rebuilt Transmissions, Motor Tiger Inc
                              is dedicated to serving the needs of customers
                              seeking top-quality used auto parts.
                            </p>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-b007c2c elementor-widget elementor-widget-heading"
                          data-id="b007c2c"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              Extensive Product Range
                            </h2>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-912648c elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="912648c"
                          data-element_type="widget"
                          data-widget_type="icon-list.default"
                        >
                          <div className="elementor-widget-container">
                            <ul className="elementor-icon-list-items">
                              <li className="elementor-icon-list-item">
                                <span className="elementor-icon-list-icon">
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-fas-dot-circle"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path>
                                  </svg>{" "}
                                </span>
                                <span className="elementor-icon-list-text">
                                  Used Engines
                                </span>
                              </li>
                              <li className="elementor-icon-list-item">
                                <span className="elementor-icon-list-icon">
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-fas-dot-circle"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path>
                                  </svg>{" "}
                                </span>
                                <span className="elementor-icon-list-text">
                                  Used Transmissions
                                </span>
                              </li>
                              <li className="elementor-icon-list-item">
                                <span className="elementor-icon-list-icon">
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-fas-dot-circle"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path>
                                  </svg>{" "}
                                </span>
                                <span className="elementor-icon-list-text">
                                  Used Auto Parts
                                </span>
                              </li>
                              <li className="elementor-icon-list-item">
                                <span className="elementor-icon-list-icon">
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-fas-dot-circle"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path>
                                  </svg>{" "}
                                </span>
                                <span className="elementor-icon-list-text">
                                  Rebuilt Engines Parts
                                </span>
                              </li>
                              <li className="elementor-icon-list-item">
                                <span className="elementor-icon-list-icon">
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-fas-dot-circle"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path>
                                  </svg>{" "}
                                </span>
                                <span className="elementor-icon-list-text">
                                  Rebuilt Transmissions
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-70e570a elementor-widget elementor-widget-partdo-button"
                          data-id="70e570a"
                          data-element_type="widget"
                          data-widget_type="partdo-button.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="partdo-button">
                              <a className="btn partdo-btn " href="index.html#">
                                Know More{" "}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-17b0c7e elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="17b0c7e"
          data-element_type="section"
          data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
        >
          <div className="elementor-background-overlay" />
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ba646ba"
              data-id="ba646ba"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-4787cbd elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                  data-id="4787cbd"
                  data-element_type="section"
                  data-settings='{"_ha_eqh_enable":false}'
                >
                  <div className="elementor-container elementor-column-gap-wide">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-ef73ae2"
                      data-id="ef73ae2"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated custom-dflex">
                        <div
                          className="elementor-element elementor-element-691c298 ha-card--left ha-card--tablet-top ha-card--mobile-top elementor-widget elementor-widget-ha-card happy-addon ha-card custom-card-width"
                          data-id="691c298"
                          data-element_type="widget"
                          data-widget_type="ha-card.default"
                        >
                          <div className="elementor-widget-container">
                            <figure className="ha-card-figure">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={960}
                                height={600}
                                src="assets/files/uploads/2024/02/engine-1024x640.jpg"
                                className="attachment-large size-large wp-image-4413"
                                alt=""
                                srcSet="assets/files/uploads/2024/02/engine-1024x640.jpg 1024w, assets/files/uploads/2024/02/engine-300x188.jpg 300w, assets/files/uploads/2024/02/engine-768x480.jpg 768w, assets/files/uploads/2024/02/engine-600x375.jpg 600w, assets/files/uploads/2024/02/engine-86x54.jpg 86w, assets/files/uploads/2024/02/engine.jpg 1080w"
                                sizes="(max-width: 960px) 100vw, 960px"
                              />
                            </figure>
                            <div className="ha-card-body">
                              <h2 className="ha-card-title">Used Engines</h2>
                              <div className="ha-card-text">
                                <p>
                                  Elevate your driving experience with our
                                  renowned high-performance used engines,
                                  carefully selected for their reliability and
                                  enhanced power.
                                </p>
                              </div>
                              <a className="ha-btn" href="/used-engines">
                                <span className="ha-btn-text">Know More</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-71794be ha-card--left ha-card--tablet-top ha-card--mobile-top elementor-widget elementor-widget-ha-card happy-addon ha-card custom-card-width"
                          data-id="71794be"
                          data-element_type="widget"
                          data-widget_type="ha-card.default"
                        >
                          <div className="elementor-widget-container">
                            <figure className="ha-card-figure">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={538}
                                height={349}
                                src="assets/files/uploads/2024/02/autoparts.jpg"
                                className="attachment-large size-large wp-image-4414"
                                alt=""
                                srcSet="assets/files/uploads/2024/02/autoparts.jpg 538w, assets/files/uploads/2024/02/autoparts-300x195.jpg 300w, assets/files/uploads/2024/02/autoparts-83x54.jpg 83w"
                                sizes="(max-width: 538px) 100vw, 538px"
                              />
                            </figure>
                            <div className="ha-card-body">
                              <h2 className="ha-card-title">
                                Used Auto Spare Parts
                              </h2>
                              <div className="ha-card-text">
                                <p>
                                  Explore our extensive collection of used auto
                                  parts, carefully curated to meet the diverse
                                  needs of your vehicle, ensuring quality and
                                  affordability.
                                </p>
                              </div>
                              <a
                                className="ha-btn"
                                href="/used-auto-spare-parts"
                              >
                                <span className="ha-btn-text">Know More</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-4ef300a ha-card--left ha-card--tablet-top ha-card--mobile-top elementor-widget elementor-widget-ha-card happy-addon ha-card custom-card-width"
                          data-id="4ef300a"
                          data-element_type="widget"
                          data-widget_type="ha-card.default"
                        >
                          <div className="elementor-widget-container">
                            <figure className="ha-card-figure">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={792}
                                height={450}
                                src="assets/files/uploads/2024/02/rebuittrans.jpg"
                                className="attachment-large size-large wp-image-4416"
                                alt=""
                                srcSet="assets/files/uploads/2024/02/rebuittrans.jpg 792w, assets/files/uploads/2024/02/rebuittrans-300x170.jpg 300w, assets/files/uploads/2024/02/rebuittrans-768x436.jpg 768w, assets/files/uploads/2024/02/rebuittrans-600x341.jpg 600w, assets/files/uploads/2024/02/rebuittrans-90x51.jpg 90w"
                                sizes="(max-width: 792px) 100vw, 792px"
                              />
                            </figure>
                            <div className="ha-card-body">
                              <h2 className="ha-card-title">
                                Rebuilt Transmissions
                              </h2>
                              <div className="ha-card-text">
                                <p>
                                  Choose Motor Tiger Inc for rebuilt
                                  transmission parts, crafted with the highest
                                  quality standards to deliver superior
                                  performance and reliability.
                                </p>
                              </div>
                              <a
                                className="ha-btn"
                                href="/rebuilt-transmissions"
                              >
                                <span className="ha-btn-text">Know More</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-06b36a8 ha-card--left ha-card--tablet-top ha-card--mobile-top elementor-widget elementor-widget-ha-card happy-addon ha-card custom-card-width"
                          data-id="06b36a8"
                          data-element_type="widget"
                          data-widget_type="ha-card.default"
                        >
                          <div className="elementor-widget-container">
                            <figure className="ha-card-figure">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={960}
                                height={640}
                                src="assets/files/uploads/2024/02/transmission-1024x683.jpg"
                                className="attachment-large size-large wp-image-4412"
                                alt=""
                                srcSet="assets/files/uploads/2024/02/transmission-1024x683.jpg 1024w, assets/files/uploads/2024/02/transmission-300x200.jpg 300w, assets/files/uploads/2024/02/transmission-768x512.jpg 768w, assets/files/uploads/2024/02/transmission-1536x1024.jpg 1536w, assets/files/uploads/2024/02/transmission-2048x1366.jpg 2048w, assets/files/uploads/2024/02/transmission-600x400.jpg 600w, assets/files/uploads/2024/02/transmission-81x54.jpg 81w"
                                sizes="(max-width: 960px) 100vw, 960px"
                              />
                            </figure>
                            <div className="ha-card-body">
                              <h2 className="ha-card-title">
                                Used Transmissions
                              </h2>
                              <div className="ha-card-text">
                                <p>
                                  Discover a diverse range of reliable used
                                  transmissions, inspected for quality to ensure
                                  optimal performance in your vehicle.
                                </p>
                              </div>
                              <a
                                className="ha-btn"
                                href="/used-transmissions"
                              >
                                <span className="ha-btn-text">Know More</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-ce689b8 ha-card--left ha-card--tablet-top ha-card--mobile-top elementor-widget elementor-widget-ha-card happy-addon ha-card custom-card-width-100"
                          data-id="ce689b8"
                          data-element_type="widget"
                          data-widget_type="ha-card.default"
                        >
                          <div className="elementor-widget-container">
                            <figure className="ha-card-figure">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={960}
                                height={720}
                                src="assets/files/uploads/2024/02/rebuit-part-1024x768.jpg"
                                className="attachment-large size-large wp-image-4415"
                                alt=""
                                srcSet="assets/files/uploads/2024/02/rebuit-part-1024x768.jpg 1024w, assets/files/uploads/2024/02/rebuit-part-300x225.jpg 300w, assets/files/uploads/2024/02/rebuit-part-768x576.jpg 768w, assets/files/uploads/2024/02/rebuit-part-600x450.jpg 600w, assets/files/uploads/2024/02/rebuit-part-72x54.jpg 72w, assets/files/uploads/2024/02/rebuit-part.jpg 1200w"
                                sizes="(max-width: 960px) 100vw, 960px"
                              />
                            </figure>
                            <div className="ha-card-body">
                              <h2 className="ha-card-title">Rebuilt Engines</h2>
                              <div className="ha-card-text">
                                <p>
                                  Opt for our rebuilt auto parts to experience
                                  peak performance, offering enhanced power and
                                  longevity for your vehicle.
                                </p>
                              </div>
                              <a className="ha-btn" href="/rebuilt-engines">
                                <span className="ha-btn-text">Know More</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-bb94438 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="bb94438"
          data-element_type="section"
          data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-71d96ef"
              data-id="71d96ef"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-7139bb7 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="7139bb7"
                  data-element_type="section"
                  data-settings='{"_ha_eqh_enable":"yes","_ha_eqh_widget":["ha-infobox"],"background_background":"classic","_ha_eqh_to":"widget","_ha_eqh_disable_on_tablet":"no","_ha_eqh_disable_on_mobile":"yes"}'
                >
                  <div className="elementor-background-overlay" />
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-26e5ec4"
                      data-id="26e5ec4"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-1d63bc9 elementor-widget elementor-widget-heading"
                          data-id="1d63bc9"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              Why Choose Motor Tiger Inc. for Your Auto Spare
                              Parts Needs?
                            </h2>
                          </div>
                        </div>
                        <section
                          className="elementor-section elementor-inner-section elementor-element elementor-element-2cda842 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                          data-id="2cda842"
                          data-element_type="section"
                          data-settings='{"_ha_eqh_enable":false}'
                        >
                          <div className="elementor-container elementor-column-gap-default">
                            <div
                              className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-74a6e28"
                              data-id="74a6e28"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-28b1fce elementor-widget elementor-widget-accordion"
                                  data-id="28b1fce"
                                  data-element_type="widget"
                                  data-widget_type="accordion.default"
                                >
                                  <div className="elementor-widget-container">
                                    <style
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "\n                                                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                                                .elementor-accordion {\n                                                                                    text-align: start\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-accordion-item {\n                                                                                    border: 1px solid #d5d8dc\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-accordion-item+.elementor-accordion-item {\n                                                                                    border-top: none\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-title {\n                                                                                    margin: 0;\n                                                                                    padding: 15px 20px;\n                                                                                    font-weight: 700;\n                                                                                    line-height: 1;\n                                                                                    cursor: pointer;\n                                                                                    outline: none\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-title .elementor-accordion-icon {\n                                                                                    display: inline-block;\n                                                                                    width: 1.5em\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-title .elementor-accordion-icon svg {\n                                                                                    width: 1em;\n                                                                                    height: 1em\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-title .elementor-accordion-icon.elementor-accordion-icon-right {\n                                                                                    float: right;\n                                                                                    text-align: right\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-title .elementor-accordion-icon.elementor-accordion-icon-left {\n                                                                                    float: left;\n                                                                                    text-align: left\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-title .elementor-accordion-icon .elementor-accordion-icon-closed {\n                                                                                    display: block\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-title .elementor-accordion-icon .elementor-accordion-icon-opened,\n                                                                                .elementor-accordion .elementor-tab-title.elementor-active .elementor-accordion-icon-closed {\n                                                                                    display: none\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-title.elementor-active .elementor-accordion-icon-opened {\n                                                                                    display: block\n                                                                                }\n\n                                                                                .elementor-accordion .elementor-tab-content {\n                                                                                    display: none;\n                                                                                    padding: 15px 20px;\n                                                                                    border-top: 1px solid #d5d8dc\n                                                                                }\n\n                                                                                @media (max-width:767px) {\n                                                                                    .elementor-accordion .elementor-tab-title {\n                                                                                        padding: 12px 15px\n                                                                                    }\n\n                                                                                    .elementor-accordion .elementor-tab-title .elementor-accordion-icon {\n                                                                                        width: 1.2em\n                                                                                    }\n\n                                                                                    .elementor-accordion .elementor-tab-content {\n                                                                                        padding: 7px 15px\n                                                                                    }\n                                                                                }\n\n                                                                                .e-con-inner>.elementor-widget-accordion,\n                                                                                .e-con>.elementor-widget-accordion {\n                                                                                    width: var(--container-widget-width);\n                                                                                    --flex-grow: var(--container-widget-flex-grow)\n                                                                                }\n                                                                            "
                                      }}
                                    />
                                    <div className="elementor-accordion">
                                      <div className="elementor-accordion-item">
                                        <div
                                          id="elementor-tab-title-4261"
                                          className="elementor-tab-title"
                                          data-tab={1}
                                          role="button"
                                          aria-controls="elementor-tab-content-4261"
                                          aria-expanded="false"
                                        >
                                          <span
                                            className="elementor-accordion-icon elementor-accordion-icon-left"
                                            aria-hidden="true"
                                          >
                                            <span className="elementor-accordion-icon-closed">
                                              <svg
                                                className="e-font-icon-svg e-fas-plus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                            <span className="elementor-accordion-icon-opened">
                                              <svg
                                                className="e-font-icon-svg e-fas-minus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                          </span>
                                          <a
                                            className="elementor-accordion-title"
                                            tabIndex={0}
                                          >
                                            Economical pricing and personalized
                                            Deals tailored for your budget and
                                            preferences{" "}
                                          </a>
                                        </div>
                                        <div
                                          id="elementor-tab-content-4261"
                                          className="elementor-tab-content elementor-clearfix"
                                          data-tab={1}
                                          role="region"
                                          aria-labelledby="elementor-tab-title-4261"
                                        >
                                          <p>
                                            Motor Tiger Inc. always believes in
                                            offering a fair pricing to all it’s
                                            customers. Customer satisfaction is
                                            our top most priority and every team
                                            member at Motor Tiger Inc. is
                                            working exclusively in that
                                            direction. Every effort is given in
                                            understanding the basic needs of
                                            Customers and than designing a
                                            personalised offers to all our
                                            customers. Experience the benefits
                                            of our tailored pricing and
                                            personalized deals, designed to make
                                            your experience with us both
                                            cost-effective &amp; satisfying.
                                          </p>
                                        </div>
                                      </div>
                                      <div className="elementor-accordion-item">
                                        <div
                                          id="elementor-tab-title-4262"
                                          className="elementor-tab-title"
                                          data-tab={2}
                                          role="button"
                                          aria-controls="elementor-tab-content-4262"
                                          aria-expanded="false"
                                        >
                                          <span
                                            className="elementor-accordion-icon elementor-accordion-icon-left"
                                            aria-hidden="true"
                                          >
                                            <span className="elementor-accordion-icon-closed">
                                              <svg
                                                className="e-font-icon-svg e-fas-plus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                            <span className="elementor-accordion-icon-opened">
                                              <svg
                                                className="e-font-icon-svg e-fas-minus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                          </span>
                                          <a
                                            className="elementor-accordion-title"
                                            tabIndex={0}
                                          >
                                            Extensive Nationwide Inventory:
                                            Access Auto Parts Across Every
                                            State.{" "}
                                          </a>
                                        </div>
                                        <div
                                          id="elementor-tab-content-4262"
                                          className="elementor-tab-content elementor-clearfix"
                                          data-tab={2}
                                          role="region"
                                          aria-labelledby="elementor-tab-title-4262"
                                        >
                                          <ul>
                                            <li>
                                              Our wide network of inventory
                                              spans across all states of the
                                              country, ensuring easy access to
                                              auto parts no matter where you are
                                              located.
                                            </li>
                                            <li>
                                              With our extensive nationwide
                                              inventory, finding the right auto
                                              part for your vehicle has never
                                              been easier.
                                            </li>
                                            <li>
                                              We have strategically established
                                              our inventory across the country,
                                              allowing us to serve customers
                                              from coast to coast.
                                            </li>
                                            <li>
                                              Our expansive network ensures that
                                              you have a wide range of options
                                              to choose from, increasing the
                                              likelihood of finding the exact
                                              part you need.
                                            </li>
                                            <li>
                                              We understand the importance of
                                              convenience, which is why we have
                                              invested in a vast inventory that
                                              covers all states of the Country.
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="elementor-accordion-item">
                                        <div
                                          id="elementor-tab-title-4263"
                                          className="elementor-tab-title"
                                          data-tab={3}
                                          role="button"
                                          aria-controls="elementor-tab-content-4263"
                                          aria-expanded="false"
                                        >
                                          <span
                                            className="elementor-accordion-icon elementor-accordion-icon-left"
                                            aria-hidden="true"
                                          >
                                            <span className="elementor-accordion-icon-closed">
                                              <svg
                                                className="e-font-icon-svg e-fas-plus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                            <span className="elementor-accordion-icon-opened">
                                              <svg
                                                className="e-font-icon-svg e-fas-minus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                          </span>
                                          <a
                                            className="elementor-accordion-title"
                                            tabIndex={0}
                                          >
                                            Successfully delivering the after
                                            sales Commitments – Our promise to
                                            you.
                                          </a>
                                        </div>
                                        <div
                                          id="elementor-tab-content-4263"
                                          className="elementor-tab-content elementor-clearfix"
                                          data-tab={3}
                                          role="region"
                                          aria-labelledby="elementor-tab-title-4263"
                                        >
                                          <p>
                                            Motor Tiger Inc. after-sales
                                            commitment is a testament to our
                                            dedication to your complete
                                            satisfaction and our ongoing
                                            commitment to your automotive needs.
                                            Our dedicated team ensures that your
                                            needs are met even after your
                                            purchase, delivering on our
                                            promises. From returns, replacements
                                            to efficient troubleshooting, we go
                                            the extra mile to address any
                                            concerns you may have. At Motor
                                            Tiger Inc., we take pride in
                                            successfully delivering on our
                                            after-sales commitments, ensuring
                                            your continued trust and loyalty.
                                          </p>
                                        </div>
                                      </div>
                                      <div className="elementor-accordion-item">
                                        <div
                                          id="elementor-tab-title-4264"
                                          className="elementor-tab-title"
                                          data-tab={4}
                                          role="button"
                                          aria-controls="elementor-tab-content-4264"
                                          aria-expanded="false"
                                        >
                                          <span
                                            className="elementor-accordion-icon elementor-accordion-icon-left"
                                            aria-hidden="true"
                                          >
                                            <span className="elementor-accordion-icon-closed">
                                              <svg
                                                className="e-font-icon-svg e-fas-plus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                            <span className="elementor-accordion-icon-opened">
                                              <svg
                                                className="e-font-icon-svg e-fas-minus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                          </span>
                                          <a
                                            className="elementor-accordion-title"
                                            tabIndex={0}
                                          >
                                            Lightning-Fast Delivery - Get Your
                                            Order in Record Time at your place
                                            in no cost.
                                          </a>
                                        </div>
                                        <div
                                          id="elementor-tab-content-4264"
                                          className="elementor-tab-content elementor-clearfix"
                                          data-tab={4}
                                          role="region"
                                          aria-labelledby="elementor-tab-title-4264"
                                        >
                                          <p>
                                            “No cost shipping”. We understand
                                            the importance of timely delivery,
                                            and we strive to exceed your
                                            expectations in speed and
                                            efficiency. Experience the speed and
                                            efficiency of our lightning-fast
                                            delivery service. We prioritize
                                            prompt delivery to ensure you
                                            receive your order in record time
                                            Say goodbye to long waiting periods
                                            with our swift and reliable delivery
                                            process. Our dedicated logistics
                                            team works tirelessly to get your
                                            order to your location as quickly as
                                            possible.
                                          </p>
                                        </div>
                                      </div>
                                      <div className="elementor-accordion-item">
                                        <div
                                          id="elementor-tab-title-4265"
                                          className="elementor-tab-title"
                                          data-tab={5}
                                          role="button"
                                          aria-controls="elementor-tab-content-4265"
                                          aria-expanded="false"
                                        >
                                          <span
                                            className="elementor-accordion-icon elementor-accordion-icon-left"
                                            aria-hidden="true"
                                          >
                                            <span className="elementor-accordion-icon-closed">
                                              <svg
                                                className="e-font-icon-svg e-fas-plus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                            <span className="elementor-accordion-icon-opened">
                                              <svg
                                                className="e-font-icon-svg e-fas-minus"
                                                viewBox="0 0 448 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                                              </svg>
                                            </span>
                                          </span>
                                          <a
                                            className="elementor-accordion-title"
                                            tabIndex={0}
                                          >
                                            100% Quality Assurance - Ensuring
                                            Excellence in Every Auto Part.
                                          </a>
                                        </div>
                                        <div
                                          id="elementor-tab-content-4265"
                                          className="elementor-tab-content elementor-clearfix"
                                          data-tab={5}
                                          role="region"
                                          aria-labelledby="elementor-tab-title-4265"
                                        >
                                          <p>
                                            We at Motor Tiger Inc., guarantee
                                            100% quality assurance on all our
                                            auto parts, giving you peace of mind
                                            with every purchase Our commitment
                                            to quality means that every auto
                                            part we offer undergoes rigorous
                                            testing and inspection. Rest
                                            assured, our team of experts ensures
                                            that only the highest quality auto
                                            parts make it to our inventory.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-a535e1f"
                              data-id="a535e1f"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-86143e1 elementor-widget elementor-widget-image"
                                  data-id="86143e1"
                                  data-element_type="widget"
                                  data-widget_type="image.default"
                                >
                                  <div className="elementor-widget-container">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={450}
                                      height={450}
                                      src="assets/files/uploads/2024/03/about-sec-back.png"
                                      className="attachment-large size-large wp-image-4951"
                                      alt=""
                                      srcSet="assets/files/uploads/2024/03/about-sec-back.png 450w, assets/files/uploads/2024/03/about-sec-back-300x300.png 300w, assets/files/uploads/2024/03/about-sec-back-150x150.png 150w, assets/files/uploads/2024/03/about-sec-back-54x54.png 54w, assets/files/uploads/2024/03/about-sec-back-96x96.png 96w"
                                      sizes="(max-width: 450px) 100vw, 450px"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-0d04ab1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="0d04ab1"
          data-element_type="section"
          data-settings='{"_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c66474f"
              data-id="c66474f"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-d8f5ae2 elementor-widget elementor-widget-heading"
                  data-id="d8f5ae2"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h2 className="elementor-heading-title elementor-size-default">
                      How Motor Tiger Inc. Works
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-3f4696d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="3f4696d"
          data-element_type="section"
          data-settings='{"_ha_eqh_enable":false}'
        >
          <div className="elementor-container elementor-column-gap-extended">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-9acebc5"
              data-id="9acebc5"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f3a17d elementor-widget elementor-widget-partdo-banner-box"
                  data-id="4f3a17d"
                  data-element_type="widget"
                  data-widget_type="partdo-banner-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="klbth-banner style-inner color-scheme-dark space-sm align-start justify-start hover-zoom">
                      <div className="entry-wrapper overlay-10-dark-max768 dump">
                        <div className="entry-inner w-100">
                          <div className="entry-heading banner-heading">
                            <span className="badge">
                              Used Auto Parts Near You
                            </span>
                            <h2 className="entry-title font-banner-xs">
                              To simplify the search process, Motor Tiger Inc.
                              Offers an option to locate parts by Zip code.
                              Choose your Year, Make, Model &amp; Select your
                              Part
                            </h2>
                          </div>
                          <div className="entry-footer vertical banner-footer" />
                        </div>
                      </div>
                      <div className="entry-media">
                        <img
                          decoding="async"
                          src="assets/files/uploads/2022/10/banner-12-2.jpg"
                          alt="slider image"
                        />
                      </div>
                      <a className="link-mask" href="index.html">
                        {" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3b31dbd"
              data-id="3b31dbd"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-3099b88 elementor-widget elementor-widget-partdo-banner-box"
                  data-id="3099b88"
                  data-element_type="widget"
                  data-widget_type="partdo-banner-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="klbth-banner style-inner color-scheme-dark space-md align-start justify-start hover-zoom">
                      <div className="entry-wrapper overlay-10-dark-max768 dump">
                        <div className="entry-inner w-60">
                          <div className="entry-heading banner-heading">
                            <span className="badge">
                              Shipping All Around the Country
                            </span>
                            <h2 className="entry-title font-banner-xlg">
                              Regardless of your location within the country,
                              Motor Tiger Inc ensures seamless delivery of auto
                              parts straight to your doorstep &amp; Save
                              valuable time.
                            </h2>
                          </div>
                          <div className="entry-excerpt font-sm weight-300">
                            <p> </p>
                          </div>
                          <div className="entry-footer vertical banner-footer" />
                        </div>
                      </div>
                      <div className="entry-media">
                        <img
                          decoding="async"
                          src="assets/files/uploads/2022/10/banner-13.jpg"
                          alt="slider image"
                        />
                      </div>
                      <a className="link-mask" href="index.html">
                        {" "}
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-4d32268 elementor-widget elementor-widget-partdo-banner-box"
                  data-id="4d32268"
                  data-element_type="widget"
                  data-widget_type="partdo-banner-box.default"
                >
                  <div className="elementor-widget-container">
                    <div className="klbth-banner style-inner color-scheme-dark space-md align-start justify-start hover-zoom">
                      <div className="entry-wrapper overlay-10-dark-max768 dump">
                        <div className="entry-inner w-60">
                          <div className="entry-heading banner-heading">
                            <span className="badge">Customer Support</span>
                            <h2 className="entry-title font-banner-xlg">
                              Have questions or need assistance? Reach out to
                              our dedicated customer support team through our
                              toll-free number:{" "}
                            </h2>
                          </div>
                          <div className="entry-excerpt font-sm weight-300">
                            <p>+1 (855) 253-1634 , +1 (877)-473-7675 </p>
                          </div>
                          <div className="entry-footer vertical banner-footer" />
                        </div>
                      </div>
                      <div className="entry-media">
                        <img
                          decoding="async"
                          src="assets/files/uploads/2022/10/banner-14.jpg"
                          alt="slider image"
                        />
                      </div>
                      <a className="link-mask" href="index.html">
                        {" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    </div>
    {/* #page */}

    <a
      href="index.html#"
      className="scrollToTop"
      aria-label="Scroll to top button"
    />
    <div className="woosc-popup woosc-search">
      <div className="woosc-popup-inner">
        <div className="woosc-popup-content">
          <div className="woosc-popup-content-inner">
            <div className="woosc-popup-close" />
            <div className="woosc-search-input">
              <label htmlFor="woosc_search_input" />
              <input
                type="search"
                id="woosc_search_input"
                placeholder="Type any keyword to search..."
              />
            </div>
            <div className="woosc-search-result" />
          </div>
        </div>
      </div>
    </div>
    <div className="woosc-popup woosc-settings">
      <div className="woosc-popup-inner">
        <div className="woosc-popup-content">
          <div className="woosc-popup-content-inner">
            <div className="woosc-popup-close" />
            <ul className="woosc-settings-tools">
              <li>
                <label>
                  <input
                    type="checkbox"
                    className="woosc-settings-tool"
                    defaultValue="hide_similarities"
                    id="woosc_hide_similarities"
                  />{" "}
                  Hide similarities{" "}
                </label>
              </li>
              <li>
                <label>
                  <input
                    type="checkbox"
                    className="woosc-settings-tool"
                    defaultValue="highlight_differences"
                    id="woosc_highlight_differences"
                  />{" "}
                  Highlight differences{" "}
                </label>
              </li>
            </ul>
            Select the fields to be shown. Others will be hidden. Drag and drop
            to rearrange the order.
            <ul className="woosc-settings-fields">
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="ew03"
                />
                <span className="move">Image</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="btim"
                />
                <span className="move">SKU</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="m6vj"
                />
                <span className="move">Rating</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="igkn"
                />
                <span className="move">Price</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="8ips"
                />
                <span className="move">Stock</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="kh8l"
                />
                <span className="move">Availability</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="tn07"
                />
                <span className="move">Add to cart</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="e5lt"
                />
                <span className="move">Description</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="i4yp"
                />
                <span className="move">Content</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="oc43"
                />
                <span className="move">Weight</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="b7jz"
                />
                <span className="move">Dimensions</span>
              </li>
              <li className="woosc-settings-field-li">
                <input
                  type="checkbox"
                  className="woosc-settings-field"
                  defaultValue="umnf"
                />
                <span className="move">Additional information</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="woosc-popup woosc-share">
      <div className="woosc-popup-inner">
        <div className="woosc-popup-content">
          <div className="woosc-popup-content-inner">
            <div className="woosc-popup-close" />
            <div className="woosc-share-content" />
          </div>
        </div>
      </div>
    </div>
    <div
      id="woosc-area"
      className="woosc-area woosc-bar-bottom woosc-bar-right woosc-bar-click-outside-yes woosc-hide-checkout"
      data-bg-color="#292a30"
      data-btn-color="#00a0d2"
    >
      <div className="woosc-inner">
        <div className="woosc-table">
          <div className="woosc-table-inner">
            <a
              href="index.html#close"
              id="woosc-table-close"
              className="woosc-table-close hint--left"
              aria-label="Close"
            >
              <span className="woosc-table-close-icon" />
            </a>
            <div className="woosc-table-items" />
          </div>
        </div>
        <div className="woosc-bar">
          <div className="woosc-bar-notice">
            Click outside to hide the comparison bar{" "}
          </div>
          <a
            href="index.html#print"
            className="woosc-bar-print hint--top"
            aria-label="Print"
          />
          <a
            href="index.html#share"
            className="woosc-bar-share hint--top"
            aria-label="Share"
          />
          <a
            href="index.html#search"
            className="woosc-bar-search hint--top"
            aria-label="Add product"
          />
          <div className="woosc-bar-items" />
          <div className="woosc-bar-btn woosc-bar-btn-text">
            <div className="woosc-bar-btn-icon-wrapper">
              <div className="woosc-bar-btn-icon-inner">
                <span />
                <span />
                <span />
              </div>
            </div>
            Compare
          </div>
        </div>
      </div>
    </div>
    <div className="site-drawer">
      <div className="site-scroll">
        <div className="site-drawer-row site-drawer-header">
          <div className="site-brand">
            <a href="index.html" title="Motor Tiger">
            </a>
          </div>
          {/* site-brand */}
          <div className="site-close">
            {" "}
            <a href="index.html#" aria-hidden="false">
              {" "}
              <i className="klbth-icon-xmark" />
            </a>
          </div>
        </div>
        <div className="site-drawer-row site-drawer-body">
          <span className="drawer-heading">Main Menu</span>
          <nav className="klbth-menu-wrapper vertical drawer-primary">
            <ul id="menu-motor-menu" className="klbth-menu">
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-4840">
                <a href="/about">About Us</a>
              </li>
              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-4851">
                <a href="index.html#">All Categories</a>
                <ul className="sub-menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-4665">
                    <a href="/used-engines">Used Engines</a>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-4664">
                    <a href="/used-transmissions">Used Transmissions</a>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-4662">
                    <a href="/used-auto-spare-parts">
                      Used Auto Spare Parts
                    </a>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-4663">
                    <a href="/rebuilt-engines">Rebuilt Engines</a>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-4661">
                    <a href="/rebuilt-transmissions">
                      Rebuilt Transmissions
                    </a>
                  </li>
                </ul>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-4828">
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </nav>
          <span className="drawer-heading">Category Menu</span>
          <nav className="klbth-menu-wrapper vertical">
            <span className="offcanvas-heading" />
            <nav className="site-nav vertical categories"></nav>
            {/* site-nav */}
          </nav>
          <span className="drawer-heading">CONTACT DETAILS</span>
          <nav className="drawer-contacts">
            <ul>
              <li className="contact-item">
                {" "}
                <span className="contact-icon">
                  {" "}
                  <i className="klbth-icon-phone-squared" />
                </span>
                <p className="contact-detail">
                  +1 (877)-473-7675, <br />
                  +1 (855) 253-1634
                </p>
                <div className="contact-description">
                  You can call anytime from 9 am to 6 pm.
                </div>
              </li>
              <li className="contact-item">
                {" "}
                <span className="contact-icon">
                  {" "}
                  <i className="klbth-icon-envelope-filled" />
                </span>
                <p className="contact-detail">info@motortiger.com</p>
                <div className="contact-description">
                  The e-mail you sent will be returned as soon as possible.
                </div>
              </li>
            </ul>
          </nav>
        </div>
        <div className="site-drawer-row site-drawer-footer">
          <div className="site-copyright">
            <p>
              Copyright 2024 - 2025 © Motortiger. All right reserved. Powered by
              Motortiger.
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* Modal */}
    <div id="modal" className="modal">
      <div className="modal-content">
        <div className="modal-header">
          <h2 id="modalTitle" />
          <span className="close">×</span>
        </div>
        <form id="modalForm" action="process-form.php" method="post">
          <input type="text" name="name" placeholder="Name" required />
          <input type="email" name="email" placeholder="Email" required />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            required
          />
          <select name="part" required>
            <option value="">Select Part</option>
            <option value="engine">Engine</option>
            <option value="transmission">Transmission</option>
          </select>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  </div>
  );
};

export default Home;